/* Afbeeldingen die niet laden, voor elke <img> op de pagina. Mislukt een foto
   (een koude CDN vlak na een upload, een weggevallen verbinding, of een
   tabblad dat nog naar het vorige thema wijst), dan gebeurt dit:
   1. De foto wordt meteen onzichtbaar: geen kapot icoontje of alt-tekst in
      beeld. Het logo verbergen we nooit, want de tekst "Motion Key" is beter
      dan een lege plek.
   2. Na 600 ms proberen we het een keer opnieuw. De CDN negeert onbekende
      parameters; alleen een andere v= geeft een nieuw adres, dus we plakken er
      een cijfer aan. Offline wachten we tot de verbinding terug is. Lukt het,
      dan komt de foto zacht in beeld.
   3. Mislukt ook die poging voor een thema-asset (/cdn/shop/t/<id>/assets/),
      dan kijken we een keer per paginabezoek of er intussen een ander thema
      live staat. De adressen van een verwijderd thema komen nooit meer terug;
      alleen herladen helpt dan. Dat doen we een keer, hooguit eens per vijf
      minuten per pagina, en niet als de browseropslag geblokkeerd is. Is het
      thema nog hetzelfde, dan blijft de foto gewoon onzichtbaar.
   SVG's en data:-adressen slaan we over. Laadt alles gewoon, dan gebeurt hier
   niets. Bewust bovenaan dit bestand: een fout verderop kan dit dan niet
   uitschakelen. */
(function () {
  var rustig = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var THEMA = /\/cdn\/shop\/t\/(\d+)\/assets\//;
  var nieuwAdres = function (url) {
    url = String(url || '').replace(/^\s+|\s+$/g, '');
    if (!url || /[\s,]/.test(url)) { return ''; }
    if (/[?&]v=\d+/.test(url)) {
      return url.replace(/([?&]v=)(\d+)/, function (m, sleutel, cijfers) { return sleutel + cijfers + '1'; });
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'v=1';
  };
  // Een SVG zonder eigen maat meldt soms breedte 0 terwijl hij er gewoon staat.
  var overslaan = function (url) {
    url = String(url || '').replace(/^\s+|\s+$/g, '');
    return !url || /^data:/i.test(url) || /\.svg(?:[?#]|$)/i.test(url);
  };
  var isLogo = function (img) {
    try { return !!(img.matches && img.matches('.nav-logo img, .footer-brand img')); } catch (e) { return false; }
  };

  /* Stap 3, een keer per paginabezoek, ook als er meer foto's mislukken: de
     pagina zelf zonder cache opnieuw ophalen en het eerste thema-adres daarin
     vergelijken met dat van de kapotte foto. */
  var themaNagekeken = false;
  var kijkThemaNa = function (url) {
    var oud = THEMA.exec(String(url || ''));
    if (!oud || themaNagekeken) { return; }
    themaNagekeken = true;
    if (typeof fetch !== 'function') { return; }
    // Niet in de thema-editor: daar hoort de pagina bij een concept dat niet live staat.
    if (window.Shopify && window.Shopify.designMode) { return; }
    var sleutel = 'motionKeyHerlaad:' + window.location.pathname;
    try {
      var vorige = parseInt(window.sessionStorage.getItem(sleutel), 10);
      if (vorige && Math.abs(new Date().getTime() - vorige) < 3e5) { return; }
    } catch (e) { return; }
    fetch(window.location.href, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var live = THEMA.exec(String(html || ''));
        if (!live || live[1] === oud[1]) { return; }
        // Eerst vastleggen en alleen herladen als dat gelukt is: zo nooit een lus.
        var nu = String(new Date().getTime());
        try {
          window.sessionStorage.setItem(sleutel, nu);
          if (window.sessionStorage.getItem(sleutel) !== nu) { return; }
        } catch (e2) { return; }
        window.location.reload();
      })['catch'](function () {});
  };

  var toon = function (img, st) {
    // Gelukt: ook het merkteken van het script in de <head> mag weg.
    img.removeAttribute('data-mk-mislukt');
    if (!st.verborgen) { return; }
    st.verborgen = false;
    img.style.transition = rustig ? 'none' : 'opacity .45s ease';
    img.style.opacity = '';
    setTimeout(function () { if (!st.verborgen) { img.style.transition = ''; } }, 500);
  };
  var laadOpnieuw = function (img, st) {
    st.opnieuw = true;
    var picture = img.parentNode && img.parentNode.nodeName === 'PICTURE' ? img.parentNode : null;
    if (picture) {
      var bronnen = picture.querySelectorAll('source');
      for (var i = 0; i < bronnen.length; i++) {
        var nieuw = nieuwAdres(bronnen[i].getAttribute('srcset'));
        if (nieuw) { bronnen[i].setAttribute('srcset', nieuw); }
      }
    }
    var nieuwImg = nieuwAdres(img.getAttribute('src'));
    if (nieuwImg) { img.setAttribute('src', nieuwImg); }
  };
  var mislukt = function (img) {
    if (overslaan(img.getAttribute('src'))) { return; }
    var st = img._mkBeeld;
    if (!st) {
      st = img._mkBeeld = { geprobeerd: false, opnieuw: false, verborgen: false };
      img.addEventListener('load', function () { toon(img, st); });
    }
    if (isLogo(img)) {
      // Nooit verbergen, ook niet als een onerror in de pagina dat al deed.
      if (img.style.opacity === '0') { img.style.opacity = ''; }
    } else {
      st.verborgen = true;
      img.style.transition = 'none';
      img.style.opacity = '0';
    }
    // Ook de nieuwe poging mislukte: misschien staat er een ander thema live.
    if (st.opnieuw) { kijkThemaNa(img.currentSrc || img.getAttribute('src')); return; }
    // Een tweede melding voor dezelfde fout (startcontrole plus error) telt niet.
    if (st.geprobeerd) { return; }
    st.geprobeerd = true;
    setTimeout(function () {
      if (navigator.onLine === false) {
        var weerOnline = function () {
          window.removeEventListener('online', weerOnline);
          laadOpnieuw(img, st);
        };
        window.addEventListener('online', weerOnline);
      } else {
        laadOpnieuw(img, st);
      }
    }, 600);
  };

  /* Later mislukt: een lazy foto, of een die JavaScript pas later toevoegt
     (galerij, la). Een error-gebeurtenis bubbelt niet, dus luisteren we in de
     capture-fase op het hele document. */
  document.addEventListener('error', function (e) {
    var doel = e && e.target;
    if (doel && doel.nodeName === 'IMG') { mislukt(doel); }
  }, true);
  /* Al mislukt voordat dit script draaide (het staat op defer). Het script in de
     <head> merkt zulke foto's met data-mk-mislukt. */
  var beelden = document.querySelectorAll('img');
  for (var j = 0; j < beelden.length; j++) {
    var b = beelden[j];
    var kapot = b.complete && b.naturalWidth === 0 && b.getAttribute('src');
    if (kapot || (b.hasAttribute('data-mk-mislukt') && !(b.naturalWidth > 0))) { mislukt(b); }
    /* Gemerkt en onzichtbaar gemaakt, maar daarna toch geladen voordat dit
       script draaide (een <picture> die na draaien of verkleinen een andere bron
       koos): weer zacht in beeld, anders bleef hij voorgoed onzichtbaar. */
    else if (b.hasAttribute('data-mk-mislukt') && b.naturalWidth > 0 && !b._mkBeeld) {
      toon(b, { verborgen: b.style.opacity === '0' });
    }
  }
})();

(function () {
  var nav = document.querySelector('.site-nav');
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.querySelector('.mobile-menu');

  if (nav && toggle) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (menu) {
      menu.addEventListener('click', function (e) {
        if (e.target.closest('a')) {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* Escape sluit het open menu en zet de focus terug op de menuknop, zoals bij
       elk uitklapmenu. Staat de la erboven open, dan is Escape eerst voor de la.
       De focus alleen verplaatsen als die er via het toetsenbord kwam (zie
       MotionToets verderop); na een tik blijft hij waar hij was. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !nav.classList.contains('is-open')) { return; }
      if (document.body.classList.contains('cart-locked')) { return; }
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (window.MotionToets && window.MotionToets()) { toggle.focus({ preventScroll: true }); }
    });

    var mq = window.matchMedia('(max-width: 768px)');
    var onChange = function () {
      if (!mq.matches) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  var faqItems = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));
  if (faqItems.length) {
    faqItems.forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var b = other.querySelector('.faq-q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Een link naar een losse vraag, zoals de tegels op de supportpagina, opent
       die vraag meteen en zet hem onder de vaste navigatie in beeld. Zonder dit
       land je wel op de goede plek, maar op een dichtgeklapt item. */
    var opAnker = function () {
      var id = (window.location.hash || '').replace('#', '');
      if (!id) { return; }
      var doel = document.getElementById(id);
      if (!doel || doel.className.indexOf('faq-item') === -1) { return; }
      var knop = doel.querySelector('.faq-q');
      // via de knop, zodat de andere items netjes dichtgaan
      if (knop && doel.className.indexOf('is-open') === -1) { knop.click(); }
      /* Even zonder het zachte scrollen uit de stylesheet: bij het openen van
         een pagina moet de vraag er meteen staan, niet ernaartoe glijden. */
      var wortel = document.documentElement;
      var oudGedrag = wortel.style.scrollBehavior;
      wortel.style.scrollBehavior = 'auto';
      var y = doel.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo(0, y < 0 ? 0 : y);
      wortel.style.scrollBehavior = oudGedrag;
    };
    window.addEventListener('hashchange', opAnker);
    opAnker();
    /* Nog een keer na het laden van de plaatjes: dit script draait met defer,
       dus de browser zet de scrollpositie daarna nog terug, en het openklappen
       verandert de hoogte van de pagina alsnog. */
    window.addEventListener('load', opAnker);
  }

  var rail = document.querySelector('.rail');
  if (rail) {
    var scrollRail = function (dir) {
      rail.scrollBy({ left: dir * (rail.clientWidth * 0.8), behavior: 'smooth' });
    };
    var prev = document.querySelector('.rail-prev');
    var next = document.querySelector('.rail-next');
    if (prev) prev.addEventListener('click', function () { scrollRail(-1); });
    if (next) next.addEventListener('click', function () { scrollRail(1); });
  }

  // Swipe indicator under the lifestyle rail — only meaningful once the tiles
  // actually overflow (mobile), so it hides itself on wider screens.
  Array.prototype.slice.call(document.querySelectorAll('.lifestyle-grid')).forEach(function (rail) {
    var ind = document.createElement('div');
    ind.className = 'rail-ind';
    ind.setAttribute('aria-hidden', 'true');
    ind.innerHTML = '<span class="rail-ind-track"><span class="rail-ind-bar"></span></span>';
    if (rail.parentNode) rail.parentNode.insertBefore(ind, rail.nextSibling);
    var bar = ind.querySelector('.rail-ind-bar');
    var max = 0;
    var breedte = 0;
    var wachtend = false;

    // scrollWidth en clientWidth uitlezen dwingt de browser tot een
    // layout-berekening. Tijdens een swipe vuurt scroll tientallen keren per
    // seconde, dus dat meten we alleen bij het opstarten en bij een resize.
    var meet = function () {
      max = rail.scrollWidth - rail.clientWidth;
      if (max <= 4) { ind.style.display = 'none'; return; }
      ind.style.display = '';
      breedte = Math.max((rail.clientWidth / rail.scrollWidth) * 100, 18);
      bar.style.width = breedte + '%';
      teken();
    };

    // Alleen transform, want dat kan de browser afhandelen zonder opnieuw te
    // rekenen aan de layout.
    var teken = function () {
      wachtend = false;
      if (max <= 4) { return; }
      var voortgang = rail.scrollLeft / max;
      bar.style.transform = 'translateX(' + (voortgang * (100 - breedte) / breedte * 100) + '%)';
    };

    // Eén tekening per beeldopbouw in plaats van per scroll-gebeurtenis.
    var opScroll = function () {
      if (wachtend) { return; }
      wachtend = true;
      window.requestAnimationFrame(teken);
    };

    rail.addEventListener('scroll', opScroll, { passive: true });
    window.addEventListener('resize', meet);
    meet();
  });

  // ---- Product gallery ----
  // Desktop keeps one large image with thumbnails under it. On touch widths
  // that pattern breaks down: six 72px thumbnails cannot fit 375px so they
  // wrap into stacked rows, and the image itself cannot be swiped. Here the
  // same markup becomes a scroll-snapped track with dots, built from the
  // thumbnail sources — the templates stay unchanged.
  var galleryMain = document.querySelector('.gallery-main');
  var galleryThumbs = Array.prototype.slice.call(document.querySelectorAll('.gallery-thumb'));
  if (galleryMain && galleryThumbs.length) {
    var slides = galleryThumbs.map(function (thumb) {
      var thumbImg = thumb.querySelector('img');
      return {
        src: thumb.getAttribute('data-full') || (thumbImg ? thumbImg.getAttribute('src') : ''),
        alt: thumbImg ? (thumbImg.getAttribute('alt') || '') : ''
      };
    }).filter(function (s) { return s.src; });

    if (slides.length) {
      var track = document.createElement('div');
      track.className = 'gallery-track';

      slides.forEach(function (s, i) {
        var img = document.createElement('img');
        img.src = s.src;
        img.alt = s.alt;
        if (i === 0) img.className = 'is-active';
        else img.loading = 'lazy';
        // Uitpakken buiten de hoofdthread, zodat een grote foto die binnenkomt
        // geen beeldje van een lopende animatie opeet.
        img.decoding = 'async';
        track.appendChild(img);
      });

      var isNL = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase() === 'nl';
      var arrow = function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gallery-nav gallery-nav--' + dir;
        b.setAttribute('aria-label', dir === 'prev'
          ? (isNL ? 'Vorige afbeelding' : 'Previous image')
          : (isNL ? 'Volgende afbeelding' : 'Next image'));
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
          (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"></path></svg>';
        return b;
      };
      var prevBtn = arrow('prev');
      var nextBtn = arrow('next');

      galleryMain.innerHTML = '';
      galleryMain.appendChild(track);
      galleryMain.appendChild(prevBtn);
      galleryMain.appendChild(nextBtn);

      var slideEls = Array.prototype.slice.call(track.children);
      var strip = galleryThumbs[0].parentNode;
      var swipeQuery = window.matchMedia('(max-width: 768px)');
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var current = 0;
      /* Naar welke dia een geanimeerde scroll onderweg is, of null. De standen
         onderweg horen bij de vorige dia en mogen de ring niet terugtrekken. */
      var doelDia = null;

      // Keep the selected thumbnail in view without scrolling the page, so
      // swiping to the last photo brings its thumbnail along.
      // Ook bij vegen over de hoofdfoto schuift de strook vloeiend mee. De
      // animatie hieronder start telkens vanaf de huidige stand, dus een nieuwe
      // wissel halverwege buigt de beweging af in plaats van te springen; een
      // sprong zonder animatie zag er niet mooi uit (Karan).
      /* Eigen animatie voor de strook, dezelfde als bij de tabjes van de
         features: een halve seconde die zacht uitrolt, in plaats van de
         mechanische scrollTo-smooth van de browser. */
      var stripAnim = null;
      var schuifStrip = function (doel, direct) {
        if (stripAnim) { cancelAnimationFrame(stripAnim); stripAnim = null; }
        doel = Math.max(0, Math.min(doel, strip.scrollWidth - strip.clientWidth));
        if (motionQuery.matches) { strip.scrollLeft = doel; return; }
        var van = strip.scrollLeft;
        var afstand = doel - van;
        if (Math.abs(afstand) < 1) { return; }
        var duur = 520;
        var begin = null;
        var stap = function (nu) {
          if (begin === null) { begin = nu; }
          var t = Math.min(1, (nu - begin) / duur);
          var e = 1 - Math.pow(1 - t, 3);
          strip.scrollLeft = van + afstand * e;
          if (t < 1) { stripAnim = requestAnimationFrame(stap); } else { stripAnim = null; }
        };
        stripAnim = requestAnimationFrame(stap);
      };
      var revealThumb = function (i, direct) {
        var el = galleryThumbs[i];
        if (!el || strip.scrollWidth <= strip.clientWidth) return;
        // Measure against the strip itself: offsetLeft is relative to the
        // nearest positioned ancestor, which is not the strip here.
        var stripBox = strip.getBoundingClientRect();
        var rand = function (n) {
          var b = galleryThumbs[n].getBoundingClientRect();
          var l = b.left - stripBox.left + strip.scrollLeft;
          return { l: l, r: l + b.width };
        };
        /* Niet alleen de gekozen miniatuur in beeld, maar ook zijn buren: klik je
           op de laatste die zichtbaar is, dan schuift de volgende binnen, en aan
           de linkerkant de vorige. Zo zie je altijd dat er nog meer foto's zijn,
           net als bij de tabjes van de features. */
        var marge = 14;
        var zicht = strip.scrollLeft;
        var breed = strip.clientWidth;
        var zelf = rand(i);
        var volgende = rand(Math.min(i + 1, galleryThumbs.length - 1));
        var vorige = rand(Math.max(i - 1, 0));
        var doel = null;
        if (volgende.r + marge > zicht + breed) doel = volgende.r + marge - breed;
        else if (vorige.l - marge < zicht) doel = vorige.l - marge;
        if (doel === null) return;
        // Past het niet allemaal (een heel smalle strook), dan wint de gekozen
        // miniatuur zelf: die moet altijd helemaal zichtbaar zijn.
        if (zelf.l < doel) doel = zelf.l - 4;
        if (zelf.r > doel + breed) doel = zelf.r + 4 - breed;
        schuifStrip(doel, direct);
      };

      var setActive = function (i, direct) {
        current = i;
        galleryThumbs.forEach(function (el, n) {
          el.classList.toggle('is-active', n === i);
          el.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        /* Verdwijnt zo de pijl die de focus heeft (aan het begin of het eind), dan
           gaat de focus naar de andere pijl; anders viel een toetsenbordgebruiker
           terug naar het begin van de pagina. Alleen als die pijl de focus al had,
           en die er via het toetsenbord kwam (MotionToets, verderop). Na een klik
           bleef de focus anders op de andere pijl staan: Spatie scrolde dan de
           pagina niet meer, maar zette de foto een terug. */
        var naar = null;
        if (window.MotionToets && window.MotionToets()) {
          naar = (i === 0 && document.activeElement === prevBtn) ? nextBtn
            : ((i === slides.length - 1 && document.activeElement === nextBtn) ? prevBtn : null);
        }
        // Only offer the direction that exists, so the arrows double as a
        // position cue rather than a dead button at either end.
        prevBtn.hidden = i === 0;
        nextBtn.hidden = i === slides.length - 1;
        if (naar && !naar.hidden) { naar.focus({ preventScroll: true }); }
        revealThumb(i, direct);
        /* De grote foto pas wisselen als hij uitgepakt klaarstaat. Anders toont
           de browser een frame lang een leeg vak, en pakt hij de foto uit in
           precies de frames waarin de strook begint te schuiven; dat liet de
           strook op pc soms even haperen (Karan). Bij snel doorklikken wint de
           laatste klik, ook als een eerdere foto later klaar is. */
        var foto = slideEls[i];
        var toon = function () {
          if (current !== i) { return; }
          slideEls.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
        };
        if (foto.loading === 'lazy') { foto.loading = 'eager'; }
        if (foto.decode && !foto.classList.contains('is-active')) { foto.decode().then(toon, toon); }
        else { toon(); }
        // De volgende en vorige grote foto alvast laden: een foto die pas tijdens
        // het schuiven binnenkomt, laat de animatie haperen (Karan zag dat naar
        // rechts, bij de laatste foto).
        [i + 1, i - 1].forEach(function (n) {
          var buur = slideEls[n];
          if (buur && buur.loading === 'lazy') { buur.loading = 'eager'; }
        });
      };
      var goTo = function (i) {
        if (swipeQuery.matches && track.clientWidth) {
          doelDia = i;
          track.scrollTo({ left: i * track.clientWidth, behavior: motionQuery.matches ? 'auto' : 'smooth' });
        }
        setActive(i);
      };

      galleryThumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });
      prevBtn.addEventListener('click', function () { if (current > 0) goTo(current - 1); });
      nextBtn.addEventListener('click', function () { if (current < slides.length - 1) goTo(current + 1); });

      setActive(0);

      var pending = false;
      track.addEventListener('scroll', function () {
        if (pending || !swipeQuery.matches || !track.clientWidth) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          // Alleen bijwerken als er echt een andere foto in beeld staat; anders
          // liep dit blok de hele veeg door voor niets.
          var pos = track.scrollLeft / track.clientWidth;
          var i = Math.round(pos);
          if (doelDia !== null) {
            // Een geanimeerde scroll is onderweg: wachten tot hij er is.
            if (i === doelDia) { doelDia = null; }
            return;
          }
          // Pas wisselen als de veeg duidelijk voorbij het midden is: 60% van een
          // dia. Wisselde het precies op de helft, dan sprong de ring bij een
          // vinger die rond het midden aarzelde, of een foto die terugveerde,
          // heen en weer: vooruit, terug, weer vooruit (Karan). Een veeg die
          // doorgaat of uitrolt op de volgende foto haalt de 60% altijd.
          if (i !== current && Math.abs(pos - current) >= 0.6) { setActive(i, true); }
        });
      }, { passive: true });
      /* Raakt de bezoeker het spoor zelf aan, dan laat de bewaking los -- ook
         als de geanimeerde scroll zijn doel nooit haalt, blijft vegen werken. */
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (soort) {
        track.addEventListener(soort, function () { doelDia = null; }, { passive: true });
      });
    }
  }

  // ---- Cart (local demo — the Shopify theme swaps this for the real cart).
  // Pricing mirrors the store's automatic discount: 10% off from 2 keys.
  // Same formatter as the theme; the demo always presents EUR.
  var MONEY_STYLES = {
    EUR: { pre: '€', dec: ',', grp: '.' },
    GBP: { pre: '£', dec: '.', grp: ',' },
    USD: { pre: '$', dec: '.', grp: ',' },
    DKK: { post: ' kr.', dec: ',', grp: '.' },
    SEK: { post: ' kr', dec: ',', grp: ' ' },
    PLN: { post: ' zł', dec: ',', grp: ' ' },
    CZK: { post: ' Kč', dec: ',', grp: ' ' },
    AUD: { pre: '$', dec: '.', grp: ',' }
  };
  /* De winkel bepaalt de munt, niet dit bestand. Het thema zet hem op de body
     zodat de eerste weergave al klopt; /cart.js overschrijft hem daarna met wat
     de winkelwagen echt gebruikt. Stond hier vast 'EUR', dan zag een Amerikaanse
     klant euro-tekens bij dollarbedragen. */
  var cartCurrency = ((window.MotionCart && window.MotionCart.currency) || 'EUR').toUpperCase();
  /* De munt waarin Liquid de prijzen op DEZE pagina schreef. /cart.js kan
     cartCurrency later omzetten (een oud tabblad na een landwissel); de prijzen
     van de pakketkaarten blijven dan in hun eigen munt staan. */
  var paginaMunt = cartCurrency;

  /* De toegepaste kortingscodes als chipje bij het product, in de stijl van
     de Shopify-checkout. De titel komt uit de mand van de winkel; hij gaat
     door escapeer() omdat de regel eromheen met innerHTML wordt gezet. */
  var escapeer = function (t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };
  var codeChips = function () {
    if (!inWinkel || !winkelCodes.length) { return ''; }
    return '<div class="dl-codes">' + winkelCodes.map(function (t) {
      return '<span class="dl-code">' + LABEL_SVG + escapeer(t) + '</span>';
    }).join('') + '</div>';
  };

  // Zonder munt geldt die van de winkelwagen (de la); de pagina geeft paginaMunt mee.
  var fmtCents = function (cents, munt) {
    var style = MONEY_STYLES[munt || cartCurrency] || MONEY_STYLES.EUR;
    var abs = Math.abs(cents);
    var units = Math.floor(abs / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, style.grp);
    var frac = ('0' + (abs % 100)).slice(-2);
    return (cents < 0 ? '−' : '') + (style.pre || '') + units + style.dec + frac + (style.post || '');
  };
  var UNIT_CENTS = 5995;
  // Mirrors Shopify's per-unit rounding of the 10% automatic discount.
  var lineCents = function (qty) {
    // Shopify past de 10% toe op het regeltotaal. Per stuk afronden liet een
    // halve cent vallen, waardoor de kaart een cent hoger stond dan de kassa.
    if (qty < 2) { return UNIT_CENTS * qty; }
    var regel = UNIT_CENTS * qty;
    return regel - Math.round(regel * 0.10);
  };
  var LABEL_SVG = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L2 12V4a2 2 0 0 1 2-2h8l8.6 8.6a2 2 0 0 1 0 2.8z"></path><circle cx="7.2" cy="7.2" r="1.1"></circle></svg>';
  var SHIELD_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1F8A5B" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.2-2.9 7.4-7 8.5-4.1-1.1-7-4.3-7-8.5V6z"></path><path d="M9 11.5l2 2 4-4"></path></svg>';
  var TRUCK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1F8A5B" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7.5h11v8H3z"></path><path d="M14 10h3.5l3 3v2.5H14z"></path><circle cx="7" cy="17.5" r="1.6"></circle><circle cx="17.5" cy="17.5" r="1.6"></circle></svg>';
  var LOCK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1F8A5B" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="1.6"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path></svg>';
  // Drawer copy follows the page language (<html lang>): en default, nl for the NL preview.
  var T = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase() === 'nl' ? {
    cartTitle: 'Je winkelwagen', close: 'Winkelwagen sluiten',
    empty: 'Je winkelwagen is leeg.', laadFout: 'We konden je winkelwagen even niet ophalen. Ververs de pagina.', keep: 'Verder winkelen',
    stuks: [' stuk', ' stuks'], save: 'Bespaar ', remove: 'Verwijderen',
    dec: 'Minder', inc: 'Meer', bundle: 'Korting', subtotal: 'Subtotaal',
    checkout: 'Afrekenen', atc: 'In winkelwagen — ',
    shipping: 'Verzending', free: 'Gratis', total: 'Totaal',
    trustLead: '30 dagen geld-terug-garantie',
    trust1: 'Gratis verzending', trust2: 'Veilig afrekenen'
  } : {
    cartTitle: 'Your cart', close: 'Close cart',
    empty: 'Your cart is empty.', laadFout: 'We could not load your cart just now. Please refresh the page.', keep: 'Keep shopping',
    stuks: [' device', ' devices'], save: 'Save ', remove: 'Remove',
    dec: 'Decrease', inc: 'Increase', bundle: 'Discount', subtotal: 'Subtotal',
    checkout: 'Checkout', atc: 'Add to cart — ',
    shipping: 'Shipping', free: 'Free', total: 'Total',
    trustLead: '30-day money-back guarantee',
    trust1: 'Free shipping', trust2: 'Secure checkout'
  };
  /* In de winkel is Shopify de bron van de winkelwagen; op de losse preview van
     de site is dat de browseropslag. De la eronder werkt met dezelfde vorm, dus
     hij hoeft niet te weten waar de regels vandaan komen. */
  var inWinkel = document.body.hasAttribute('data-shop');
  /* In de winkel serveert Shopify de beelden vanaf een eigen adres, dus dat pad
     komt uit de pagina in plaats van hier vast te staan. */
  var THUMB = document.body.getAttribute('data-cart-img') || 'assets/cart-thumb.jpg';
  /* In de winkel stuurt Shopify bij elke regel de foto van dat product mee.
     Die gebruiken we, zodat de la altijd de voorfoto van de listing toont --
     ook als die later wisselt, zonder dat hier iets voor hoeft te veranderen. */
  var winkelFoto = null;
  var winkelCart = [];      // wat Shopify nu in de winkelwagen heeft
  var winkelBevestigd = []; // de laatste stand die Shopify echt bevestigde
  var winkelId = null;      // variant-id, nodig om het aantal te wijzigen

  /* Shopify wil bij het wijzigen van een regel de sleutel van die regel, niet de
     variant. Geeft de winkel iets terug zonder regels -- een foutmelding
     bijvoorbeeld -- dan is dat geen lege winkelwagen: dan weten we het gewoon
     even niet en laten we staan wat er stond. */
  /* De bedragen komen uit de winkel zelf, niet uit een eigen berekening. Zo
     klopt het totaal ook wanneer iemand een kortingscode invult of wanneer de
     winkel een andere actie draait dan de bundelkorting. */
  var winkelBedragen = null;
  /* Welke KORTINGSCODES de winkel werkelijk heeft toegepast. Automatische
     acties (de bundelkorting) staan hier bewust niet bij: die hebben geen
     code en hoeven niet bevestigd te worden. Bron is Shopify zelf, niet
     localStorage -- dat laatste zegt alleen dat iemand op een partnerlink
     klikte, niet dat de code geldig was of nog geldig is. */
  var winkelCodes = [];

  var uitShopify = function (c) {
    if (!c || !c.items) { return null; }
    if (c.currency) { cartCurrency = String(c.currency).toUpperCase(); }
    var qty = 0, sleutel = null, regel = null;
    c.items.forEach(function (l) {
      qty += l.quantity;
      if (!sleutel) { sleutel = l.key || l.id; }
      if (!regel) { regel = l; }
    });
    winkelId = sleutel;
    /* Shopify levert een volledig adres; met een breedte erbij haalt de
       browser geen beeld van duizenden pixels op voor een vak van 64. */
    var bron = regel && (regel.image || (regel.featured_image && regel.featured_image.url));
    winkelFoto = bron ? (bron + (bron.indexOf('?') >= 0 ? '&' : '?') + 'width=160') : null;
    winkelCodes = [];
    var pakCodes = function (lijst) {
      if (!lijst || !lijst.forEach) { return; }
      lijst.forEach(function (d) {
        var t = d && (d.type || (d.discount_application && d.discount_application.type));
        if (t !== 'discount_code') { return; }
        var titel = d.title || (d.discount_application && d.discount_application.title);
        if (titel && winkelCodes.indexOf(titel) === -1) { winkelCodes.push(titel); }
      });
    };
    pakCodes(c.cart_level_discount_applications);
    pakCodes(c.discount_applications);
    c.items.forEach(function (l) { pakCodes(l.line_level_discount_allocations); });
    winkelBedragen = qty ? {
      subtotaal: c.original_total_price,      // voor korting
      totaal: c.total_price,                  // wat er te betalen valt
      korting: c.total_discount || 0,         // bundel en codes bij elkaar
      regelOrigineel: regel.original_line_price,
      regelTotaal: regel.final_line_price,
      stuk: regel.price
    } : null;
    return qty ? [{ key: 'single', qty: qty }] : [];
  };
  var neemOver = function (c) {
    var r = uitShopify(c);
    if (r !== null) { winkelCart = r; winkelBevestigd = r; winkelFout = false; winkelGeladen = true; return true; }
    return false;
  };
  /* Ging het ophalen mis, dan weten we niet wat er in de winkelwagen zit. Dan is
     "je winkelwagen is leeg" een bewering die we niet kunnen waarmaken -- en die
     een klant met drie stuks in zijn wagen ten onrechte te zien kreeg. We houden
     bij dat het misging en tonen dat in plaats van de lege staat. */
  var winkelFout = false;
  var winkelGeladen = false;
  var haalWinkel = function (klaar) {
    /* Was er bij het vertrekken of bij het antwoord een + of − onderweg, of is er
       intussen een afgerond, dan is deze stand ouder dan wat de bezoeker tikte:
       niet overnemen (de wijziging zelf zet de la straks goed). */
    var nr = afgerond, bezig = bijwerken();
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) { throw new Error('cart ' + r.status); }
        return r.json();
      })
      .then(function (c) {
        if (bezig || bijwerken() || nr !== afgerond) { if (klaar) klaar(true); return; }
        winkelFout = !neemOver(c);
        if (!winkelFout) { winkelGeladen = true; }
        if (klaar) klaar(!winkelFout);
      })
      .catch(function () {
        winkelFout = true;
        if (klaar) klaar(false);
      });
  };

  var readCart = function () {
    if (inWinkel) { return winkelCart.map(function (l) { return { key: l.key, qty: l.qty }; }); }
    try {
      var saved = JSON.parse(localStorage.getItem('motionKeyCart') || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (e) { return []; }
  };
  /* Een wijziging tegelijk naar de winkel. Tikt iemand snel + + +, dan liepen er
     drie aanvragen door elkaar: de antwoorden kwamen in willekeurige volgorde
     terug, het getal sprong heen en weer en een tik kon verloren gaan. Nu
     onthouden we alleen het laatst gewenste aantal; is de lopende aanvraag
     klaar en wil de bezoeker inmiddels iets anders, dan gaat dat erachteraan.
     Een tussentijds antwoord nemen we bewust niet over, anders zette het het
     getal terug dat de bezoeker al had getikt. */
  var wijzigBezig = false, wilAantal = null, afgerond = 0, naToevoegen = false, bezigSinds = 0;
  /* Onderweg naar Shopify? Dan zijn de bedragen in de la nog die van het oude
     aantal. De la toont dat (bedragen even vager), en Afrekenen wacht tot het
     nieuwe aantal verwerkt is: anders opende de kassa met het oude. */
  var bijwerken = function () { return inWinkel && (wijzigBezig || wilAantal !== null); };
  var naarKassa = null, kassaKlok = null;
  var gaDoor = function (nu) {
    if (!naarKassa || (!nu && bijwerken())) { return; }
    var u = naarKassa; naarKassa = null;
    clearTimeout(kassaKlok); kassaKlok = null;
    // Niets meer in de mand (intussen verwijderd)? Dan niet naar de kassa.
    if (winkelCart.length) { window.location.href = u; }
  };
  var stuurWijziging = function () {
    wijzigBezig = true;
    var gestuurd = wilAantal;
    // op de sleutel van de regel als we die hebben, anders op regelnummer
    var wijziging = winkelId ? { id: winkelId, quantity: gestuurd } : { line: 1, quantity: gestuurd };
    // Hoogstens 10 s: blijft Shopify stil, dan het foutpad, dat de la opnieuw met Shopify gelijkzet.
    var ac = window.AbortController ? new AbortController() : null;
    var stopKlok = ac ? setTimeout(function () { ac.abort(); }, 10000) : null;
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(wijziging),
      signal: ac ? ac.signal : undefined
    }).then(function (r) {
      clearTimeout(stopKlok);
      if (!r.ok) { throw new Error('wijzigen mislukt'); }
      return r.json();
    }).then(function (c) {
      wijzigBezig = false;
      afgerond++;
      if (wilAantal !== gestuurd) { stuurWijziging(); return; }
      wilAantal = null;
      // Levert de winkel geen bruikbaar antwoord, vraag het dan gewoon opnieuw
      // op in plaats van de la leeg te laten lopen.
      // Werd er intussen iets toegevoegd, dan is dit antwoord ouder dan de wagen: opnieuw ophalen.
      var vers = !naToevoegen; naToevoegen = false;
      if (vers && neemOver(c)) { renderCart(); gaDoor(); } else { haalWinkel(function (gelukt) { if (!gelukt) { neemOver(c); } renderCart(); gaDoor(); }); }
    }).catch(function () {
      clearTimeout(stopKlok);
      if (wijzigBezig) { afgerond++; }
      wijzigBezig = false;
      wilAantal = null;
      naToevoegen = false;
      // Mislukt (bijvoorbeeld niet genoeg voorraad): niet stil naar de kassa, eerst het echte aantal tonen.
      naarKassa = null; clearTimeout(kassaKlok); kassaKlok = null;
      // Meteen terug naar wat Shopify het laatst bevestigde, zodat aantal en bedragen kloppen, ook als ophalen straks mislukt.
      winkelCart = winkelBevestigd; renderCart();
      haalWinkel(function () { renderCart(); gaDoor(); });
    });
  };
  var saveCart = function (cart) {
    if (inWinkel) {
      var qty = 0;
      cart.forEach(function (l) { qty += l.qty; });
      winkelCart = qty ? [{ key: 'single', qty: qty }] : [];
      wilAantal = qty;
      if (!wijzigBezig) { stuurWijziging(); }
      return;
    }
    try { localStorage.setItem('motionKeyCart', JSON.stringify(cart)); } catch (e) {}
  };

  var overlay = document.createElement('div');
  overlay.className = 'cart-overlay';
  overlay.hidden = true;
  overlay.innerHTML =
    '<div class="cart-scrim"></div>' +
    '<div class="cart-panel" role="dialog" aria-modal="true" aria-label="' + T.cartTitle + '">' +
      '<div class="cart-head"><span class="cart-head-title">' + T.cartTitle + '</span><button class="cart-close" aria-label="' + T.close + '">×</button></div>' +
      '<div class="cart-body"></div>' +
      '<div class="cart-foot" hidden>' +
        '<div class="cart-foot-row"><span class="cf-label">' + T.subtotal + '</span><span class="cf-list"></span></div>' +
        '<div class="cart-saving-row" hidden><span>' + T.bundle + '</span><span class="cf-saving"></span></div>' +
        '<div class="cart-foot-row"><span class="cf-label">' + T.shipping + '</span><span class="cf-ship">' + T.free + '</span></div>' +
        '<div class="cart-foot-row cart-total-row"><span class="cf-label">' + T.total + '</span><span class="cf-total" aria-live="polite"></span></div>' +
        '<a class="cart-checkout" href="#">' + T.checkout + '</a>' +
        '<div class="cart-trust">' +
          '<span class="cart-trust-lead">' + SHIELD_SVG + T.trustLead + '</span>' +
          '<div class="cart-trust-row">' +
            '<span>' + TRUCK_SVG + T.trust1 + '</span>' +
            '<span>' + LOCK_SVG + T.trust2 + '</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);
  var drawerBody = overlay.querySelector('.cart-body');
  var drawerFoot = overlay.querySelector('.cart-foot');
  var drawerTotal = overlay.querySelector('.cf-total');
  var drawerList = overlay.querySelector('.cf-list');
  var drawerSavingRow = overlay.querySelector('.cart-saving-row');
  var drawerSaving = overlay.querySelector('.cf-saving');
  var drawerCheckout = overlay.querySelector('.cart-checkout');

  /* De regels worden hieronder opnieuw geschreven, en daarmee verdwijnt de knop
     die de focus had. Wie met het toetsenbord op + drukt, stond daarna nergens
     meer. We onthouden welke knop het was en zetten de focus op de nieuwe; is
     die er niet meer (de laatste verwijderd), dan op Verder winkelen. Alleen
     als de focus er via het toetsenbord kwam: na een klik stond hij anders op
     de nieuwe knop, en drukte Spatie die nog een keer in. */
  var zetFocusTerug = function (focusAct) {
    if (!focusAct) { return; }
    var doel = drawerBody.querySelector('[data-act="' + focusAct + '"]') || drawerBody.querySelector('.keep-shopping') || overlay.querySelector('.cart-close');
    if (doel) { doel.focus({ preventScroll: true }); }
  };
  var renderCart = function () {
    var actief = document.activeElement;
    // Verder winkelen heeft geen data-act; de terugval in zetFocusTerug vindt hem weer.
    var focusAct = (window.MotionToets && window.MotionToets() && actief && drawerBody.contains(actief))
      ? (actief.getAttribute('data-act') || (actief.classList.contains('keep-shopping') ? 'keep-shopping' : null)) : null;
    var cart = readCart();
    var paneel = overlay.querySelector('.cart-panel');
    var bezigNu = bijwerken();
    if (bezigNu) { paneel.setAttribute('aria-busy', 'true'); }
    else { paneel.classList.remove('is-bijwerken'); paneel.removeAttribute('aria-busy'); }
    var count = 0;
    var subtotal = 0;
    var originalSubtotal = 0;
    cart.forEach(function (l) {
      count += l.qty;
      subtotal += lineCents(l.qty);
      originalSubtotal += UNIT_CENTS * l.qty;
    });
    /* In de winkel gelden de bedragen van Shopify. Die kennen ook de
       kortingscode die iemand net heeft ingevuld; onze eigen som niet. */
    var bedragen = (inWinkel && winkelBedragen) ? winkelBedragen : null;
    if (bedragen) {
      originalSubtotal = bedragen.subtotaal;
      subtotal = bedragen.totaal;
    }

    /* Is de winkelwagen nog nooit gelukt op te halen, dan weten we niet hoeveel
       erin zit: laat badge en mandknop dan zoals Liquid ze bij het laden zette. */
    var aantalOnbekend = inWinkel && winkelFout && !winkelGeladen;
    Array.prototype.forEach.call(document.querySelectorAll('.cart-btn-badge'), function (badge) {
      if (aantalOnbekend) { return; }
      badge.hidden = count === 0;
      badge.textContent = count;
    });

    /* De knop zelf gaat mee weg bij een lege mand: een winkelmandje dat naar
       niets leidt maakt de balk alleen maar drukker. Let op -- .cart-btn heeft
       display:flex, dus zonder de bijbehorende [hidden]-regel in de stylesheet
       doet dit attribuut niets. */
    Array.prototype.forEach.call(document.querySelectorAll('.cart-btn'), function (btn) {
      if (aantalOnbekend) { return; }
      btn.hidden = count === 0;
    });

    if (cart.length === 0) {
      drawerBody.innerHTML =
        '<div class="cart-empty-state"><p>' + (winkelFout ? T.laadFout : T.empty) + '</p>' +
        '<button type="button" class="keep-shopping">' + T.keep + '</button></div>';
      zetFocusTerug(focusAct);
      drawerFoot.hidden = true;
      return;
    }
    drawerBody.innerHTML = cart.map(function (l) {
      // ook per regel gelden in de winkel de bedragen van Shopify
      var regelLijst = bedragen ? bedragen.regelOrigineel : UNIT_CENTS * l.qty;
      var regelNu = bedragen ? bedragen.regelTotaal : lineCents(l.qty);
      var saved = regelLijst - regelNu;
      var discounted = saved > 0;
      var subrow = '<span class="dl-sub-text">' + l.qty + T.stuks[l.qty === 1 ? 0 : 1] + '</span>';
      if (discounted) {
        subrow += '<s class="dl-list">' + fmtCents(regelLijst) + '</s>' +
          '<span class="save-pill">' + T.save + fmtCents(saved) + '</span>';
      }
      return '<div class="drawer-line">' +
        '<div class="dl-thumb"><img class="dl-photo" src="' + (winkelFoto || THUMB) + '" alt="Motion Key" width="120" height="120"></div>' +
        '<div class="dl-main">' +
          '<div class="dl-top"><span>Motion Key</span><span>' + fmtCents(regelNu) + '</span></div>' +
          '<div class="dl-subrow">' + subrow + '</div>' +
          codeChips() +
          '<div class="dl-controls">' +
            '<div class="dl-qty">' +
              '<button type="button" data-act="dec" data-key="' + l.key + '" aria-label="' + T.dec + '">−</button>' +
              '<span>' + l.qty + '</span>' +
              '<button type="button" data-act="inc" data-key="' + l.key + '" aria-label="' + T.inc + '">+</button>' +
            '</div>' +
            '<button type="button" class="dl-remove" data-act="remove" data-key="' + l.key + '">' + T.remove + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    zetFocusTerug(focusAct);
    drawerFoot.hidden = false;
    var savings = originalSubtotal - subtotal;
    drawerList.textContent = fmtCents(originalSubtotal);
    drawerSavingRow.hidden = savings <= 0;
    drawerSaving.textContent = '−' + fmtCents(savings);
    // Het totaal wordt voorgelezen zodra het verandert; hetzelfde bedrag opnieuw
    // schrijven zou een schermlezer het nog een keer laten zeggen.
    var totaalTekst = fmtCents(subtotal);
    if (drawerTotal.textContent !== totaalTekst) { drawerTotal.textContent = totaalTekst; }
    /* Geen bedrag op de knop: dat staat er vlak boven al bij Totaal, en zonder
       prijs oogt de knop rustiger -- net als de andere knoppen op de site. */
    drawerCheckout.textContent = T.checkout;
    /* Pas nu vager maken: de regel is net opnieuw geschreven, en nieuwe elementen
       krijgen anders geen overgang (ze stonden meteen vaag, ook bij een snel antwoord). */
    if (bezigNu && !paneel.classList.contains('is-bijwerken')) { void paneel.offsetWidth; paneel.classList.add('is-bijwerken'); bezigSinds = Date.now(); }
    else if (bezigNu && Date.now() - bezigSinds < 120) { paneel.classList.remove('is-bijwerken'); void paneel.offsetWidth; paneel.classList.add('is-bijwerken'); bezigSinds = Date.now(); }
  };

  /* De la is een venster over de pagina: de focus begint erin, Tab blijft
     erin, en bij sluiten gaat de focus terug naar waar hij vandaan kwam. Zonder
     dit tabde een toetsenbordgebruiker achter de la langs de hele pagina.
     Altijd met preventScroll: de pagina mag hierdoor nooit verschuiven. En
     alleen voor wie met het toetsenbord werkt (MotionToets, verderop): na een
     klik of tik blijft de focus waar hij was, precies zoals voorheen. Anders
     stond hij na sluiten op In winkelwagen, en legde Spatie om te scrollen er
     een Key bij; Safari zou er bovendien een rand om kunnen tekenen. */
  var cartOpener = null;
  var openCart = function () {
    var wasDicht = overlay.hidden;
    if (wasDicht) { cartOpener = document.activeElement; }
    renderCart();
    overlay.hidden = false;
    document.body.classList.add('cart-locked');
    if (wasDicht && window.MotionToets && window.MotionToets()) {
      var sluitKnop = overlay.querySelector('.cart-close');
      if (sluitKnop) { sluitKnop.focus({ preventScroll: true }); }
    }
  };
  var closeCart = function () {
    if (overlay.hidden) { return; }
    naarKassa = null; clearTimeout(kassaKlok); kassaKlok = null;
    overlay.hidden = true;
    document.body.classList.remove('cart-locked');
    var opener = cartOpener;
    cartOpener = null;
    // Gesloten met een klik of tik (sluitkruis, scrim): de focus niet aanraken.
    if (!(window.MotionToets && window.MotionToets())) { return; }
    /* De knop in de meeschuivende balk is op dat moment nog verborgen, dus dan
       terug naar de gewone knop in het koopblok. */
    var terug = (opener && opener !== document.body && document.body.contains(opener) &&
      !(opener.classList && opener.classList.contains('sticky-buy-btn')))
      ? opener : (document.querySelector('.atc-btn') || document.querySelector('.cart-btn'));
    if (terug && terug.focus) { try { terug.focus({ preventScroll: true }); } catch (e) {} }
    // Lukte dat niet (het mandje verdwijnt zodra de wagen leeg is), dan alsnog
    // naar de knop in het koopblok in plaats van nergens.
    var reserve = document.querySelector('.atc-btn');
    if (document.activeElement !== terug && reserve && reserve !== terug) { try { reserve.focus({ preventScroll: true }); } catch (e2) {} }
  };

  /* Tab mag de la niet uit zolang hij openstaat; de verborgen voet (lege mand)
     telt niet mee. */
  overlay.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') { return; }
    var kan = Array.prototype.filter.call(overlay.querySelectorAll('.cart-panel button, .cart-panel [href]'), function (el) {
      return !el.closest('[hidden]');
    });
    if (!kan.length) { return; }
    var eerste = kan[0], laatste = kan[kan.length - 1];
    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus({ preventScroll: true }); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus({ preventScroll: true }); }
  });

  overlay.querySelector('.cart-scrim').addEventListener('click', closeCart);
  overlay.querySelector('.cart-close').addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeCart();
  });
  drawerBody.addEventListener('click', function (e) {
    if (e.target.closest('.keep-shopping')) { closeCart(); return; }
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    var act = btn.getAttribute('data-act');
    var cart = readCart();
    var line = null;
    cart.forEach(function (l) { if (l.key === key) line = l; });
    if (!line) return;
    if (act === 'inc') line.qty += 1;
    if (act === 'dec') line.qty -= 1;
    if (act === 'remove' || line.qty < 1) cart = cart.filter(function (l) { return l.key !== key; });
    saveCart(cart);
    renderCart();
  });

  /* De knop in de balk opent de la, ook in de winkel: die toont daar de echte
     winkelwagen van Shopify. Wie geen JavaScript heeft volgt gewoon de link
     naar de winkelwagenpagina. */
  Array.prototype.forEach.call(document.querySelectorAll('.cart-btn'), function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (inWinkel) { haalWinkel(openCart); } else { openCart(); }
    });
  });
  /* Shopify serveert het Nederlands onder /nl. Een hardgecodeerde /checkout zet
     een Nederlandse klant bij de laatste klik terug op het Engels -- precies wat
     het loc-snippet overal elders voorkomt. Het thema geeft de wortel mee. */
  var winkelWortel = function () {
    var r = (window.MotionCart && window.MotionCart.root) || '/';
    return r === '/' ? '' : r.replace(/\/$/, '');
  };
  if (drawerCheckout && inWinkel) { drawerCheckout.setAttribute('href', winkelWortel() + '/checkout'); }
  if (drawerCheckout && inWinkel) {
    drawerCheckout.addEventListener('click', function (e) {
      // Met Ctrl/Cmd/Shift/Alt wil iemand een nieuw tabblad of venster: niet tegenhouden.
      if (!bijwerken() || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      e.preventDefault();
      if (naarKassa) { return; }
      naarKassa = drawerCheckout.getAttribute('href');
      // Blijft Shopify stil (wegvallend netwerk), dan na 4 s toch naar de kassa: die toont de echte stand.
      kassaKlok = setTimeout(function () { gaDoor(true); }, 4000);
    });
  }


  // Pack selector + add to cart (product page)
  var packCards = Array.prototype.slice.call(document.querySelectorAll('.pack-card'));
  var atcBtn = document.querySelector('.atc-btn');
  var buyNowBtn = document.querySelector('.buy-now-btn');
  if (packCards.length && atcBtn) {
    var selectedCard = packCards[0];
    // Headline price elements — they follow the pack selection.
    var priceNow = document.querySelector('.pdp-price-now');
    // De prijs staat ook in de highlights-kaart; die moet de pakketkeuze volgen.
    var echoPrices = Array.prototype.slice.call(document.querySelectorAll('.hi-high-price, [data-hero-price]'));
    var priceExtra = document.querySelector('.pdp-price-extra');
    var priceWas = document.querySelector('.pdp-price-was');
    var priceSave = document.querySelector('.pdp-price-save');
    var saveLabel = document.querySelector('.pack-card--double .save-badge');
    var syncPack = function () {
      packCards.forEach(function (card) {
        card.classList.toggle('is-selected', card === selectedCard);
        // Schermlezers horen zo welke kaart gekozen is; de ring zie je alleen.
        card.setAttribute('aria-pressed', card === selectedCard ? 'true' : 'false');
      });
      /* Twee Motion Keys is hetzelfde artikel, twee keer. Het formulier moet dus
         het aantal van de gekozen kaart meesturen. */
      var qtyVeld = document.querySelector('[data-buy-qty]');
      if (qtyVeld) { qtyVeld.value = selectedCard.getAttribute('data-qty') || '1'; }
      // Deze bedragen komen uit Liquid, dus in de munt van de pagina.
      var cents = parseInt(selectedCard.getAttribute('data-price-cents'), 10) || 0;
      var compare = parseInt(selectedCard.getAttribute('data-compare-cents') || '0', 10);
      echoPrices.forEach(function (el) { el.textContent = fmtCents(cents, paginaMunt); });
      if (priceNow) {
        priceNow.textContent = fmtCents(cents, paginaMunt);
        if (priceExtra && compare > cents) {
          if (priceWas) priceWas.textContent = fmtCents(compare, paginaMunt);
          // Reuse the pack card's badge so the wording follows the language.
          if (priceSave) priceSave.textContent = saveLabel ? saveLabel.textContent.trim() : '';
          priceExtra.hidden = false;
        } else if (priceExtra) {
          priceExtra.hidden = true;
        }
      }
      // De highlights-kaart toont de oude prijs doorgestreept bij twee stuks.
      var highWas = document.querySelector('.hi-high-was');
      if (highWas) {
        if (compare > cents) { highWas.textContent = fmtCents(compare, paginaMunt); highWas.hidden = false; }
        else { highWas.hidden = true; }
      }
      // Op de nieuwe productpagina staat er bewust geen prijs op de knop.
      if (atcBtn.hasAttribute('data-atc-plain')) { return; }
      if (compare > cents) {
        atcBtn.innerHTML = T.atc + fmtCents(cents, paginaMunt) + ' <s class="atc-compare">' + fmtCents(compare, paginaMunt) + '</s>';
      } else {
        atcBtn.textContent = T.atc + fmtCents(cents, paginaMunt);
      }
    };
    packCards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectedCard = card;
        syncPack();
      });
    });
    var addSelected = function (e) {
      var addQty = parseInt(selectedCard.getAttribute('data-qty') || '1', 10);
      /* In de winkel gaat het artikel naar de winkelwagen van Shopify en gaat
         de la open -- net als in de design file. Naar de kassa ga je pas via de
         knop in die la. Zonder JavaScript verstuurt het formulier gewoon. */
      if (inWinkel) {
        if (e && e.preventDefault) { e.preventDefault(); }
        /* Loopt er al een toevoeging, dan niets doen: een dubbelklik legde anders
           twee (of vier) Keys in de winkelwagen. Pas na preventDefault, anders
           verstuurt de tweede klik het formulier alsnog zelf. De vlag gaat er op
           elk pad weer af, ook als het mislukt. */
        if (atcBtn.getAttribute('aria-busy') === 'true') { return; }
        var vid = selectedCard.getAttribute('data-variant-id');
        if (!vid) {
          // terugval op het verborgen veld van het formulier
          var idVeld = document.querySelector('[name="id"]');
          if (idVeld) { vid = idVeld.value; }
        }
        atcBtn.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: vid, quantity: addQty })
        }).then(function (r) {
          if (!r.ok) { throw new Error('toevoegen mislukt'); }
          return r.json();
        }).then(function () {
          if (bijwerken()) {
            // Er loopt een + of − (een absoluut aantal): tel de toevoeging erbij, anders overschrijft die wijziging de nieuwe Key.
            naToevoegen = true;
            var nuQ = 0; winkelCart.forEach(function (l) { nuQ += l.qty; });
            saveCart([{ key: 'single', qty: nuQ + addQty }]);
          }
          haalWinkel(function () {
            atcBtn.removeAttribute('aria-busy');
            if (nav) nav.classList.remove('is-open');
            openCart();
          });
        }).catch(function () {
          // lukt het niet, dan alsnog langs de winkelwagenpagina van de winkel
          atcBtn.removeAttribute('aria-busy');
          window.location.href = winkelWortel() + '/cart';
        });
        return;
      }
      var cart = readCart();
      var line = null;
      cart.forEach(function (l) { if (l.key === 'single') line = l; });
      if (line) line.qty += addQty;
      else cart.push({ key: 'single', qty: addQty });
      saveCart(cart);
      if (nav) nav.classList.remove('is-open');
      openCart();
    };
    atcBtn.addEventListener('click', addSelected);
    if (buyNowBtn) buyNowBtn.addEventListener('click', addSelected);
    syncPack();

    // ---- Sticky buy bar ----
    // Slides up once the whole buy block has scrolled past, so the price and
    // button stay reachable through the long editorial page — and drops away
    // again near the footer so it never covers the final CTA. Built from the
    // buy block that already exists, so it inherits language and price; its
    // button forwards to the real atcBtn to reuse all the cart logic.
    var titleEl = document.querySelector('.pdp-title');
    var buySection = document.getElementById('buy');
    if (titleEl && buySection) {
      var thumbImg = document.querySelector('.gallery-thumb img');
      var bar = document.createElement('div');
      bar.className = 'sticky-buy';
      bar.innerHTML =
        '<div class="sticky-buy-inner">' +
          '<div class="sticky-buy-info">' +
            '<div class="sticky-buy-thumb"><img src="' + (thumbImg ? thumbImg.getAttribute('src') : '') + '" alt=""></div>' +
            '<div class="sticky-buy-text">' +
              '<span class="sticky-buy-name"></span>' +
              '<span class="sticky-buy-sub"></span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="sticky-buy-btn"></button>' +
        '</div>';
      // Geparkeerd onder de rand, dus meteen buiten de Tab-volgorde (zie updateSticky).
      bar.inert = true;
      document.body.appendChild(bar);
      bar.querySelector('.sticky-buy-name').textContent = titleEl.textContent.trim();
      var barSub = bar.querySelector('.sticky-buy-sub');
      var barBtn = bar.querySelector('.sticky-buy-btn');

      /* Dit draait bij elk scrollframe waarin de balk staat. Alleen schrijven als
         de tekst echt anders is: telkens dezelfde inhoud opnieuw zetten kost de
         browser elk frame werk. We vergelijken met wat wij het laatst schreven,
         niet met innerHTML, want dat geeft de browser anders terug (entiteiten). */
      var laatsteSub = null, laatsteKnop = null;
      var syncSticky = function () {
        // Price cell is already formatted for language and currency.
        var priceCell = document.querySelector('.pack-card.is-selected .pack-price');
        var price = priceCell ? priceCell.textContent.trim() : '';
        // Two-pack shows the money saved; single shows free shipping.
        var cents = parseInt(selectedCard.getAttribute('data-price-cents'), 10) || 0;
        var compare = parseInt(selectedCard.getAttribute('data-compare-cents') || '0', 10);
        if (compare > cents) {
          var subHtml = price + ' <span class="sticky-buy-save">· ' + T.save + fmtCents(compare - cents, paginaMunt) + '</span>';
          if (laatsteSub !== 'html:' + subHtml) { barSub.innerHTML = subHtml; laatsteSub = 'html:' + subHtml; }
        } else {
          var subTekst = price + ' · ' + T.trust1;
          if (laatsteSub !== 'tekst:' + subTekst) { barSub.textContent = subTekst; laatsteSub = 'tekst:' + subTekst; }
        }
        var knopTekst = (atcBtn.textContent || '').split('—')[0].trim();
        if (laatsteKnop !== knopTekst) { barBtn.textContent = knopTekst; laatsteKnop = knopTekst; }
        if (barBtn.disabled !== atcBtn.disabled) { barBtn.disabled = atcBtn.disabled; }
      };
      packCards.forEach(function (card) { card.addEventListener('click', syncSticky); });
      barBtn.addEventListener('click', function () { atcBtn.click(); });
      syncSticky();

      // Show once the buy block's bottom is above the viewport, hide again
      // when the footer comes within reach — matches the comp's behaviour.
      var footEl = document.querySelector('.site-footer') || document.querySelector('footer');
      var pending = false;
      var inertKlok = null;
      var updateSticky = function () {
        pending = false;
        var started = buySection.getBoundingClientRect().bottom < 0;
        var nearFoot = footEl ? footEl.getBoundingClientRect().top < window.innerHeight + 120 : false;
        var show = started && !nearFoot;
        if (show) syncSticky();
        bar.classList.toggle('is-visible', show);
        /* Weggeschoven onder de rand: ook uit de Tab-volgorde en buiten bereik
           van schermlezers. Geen zichtbaar verschil; de schaduw blijft gewoon.
           Pas als hij echt weg is: hij schuift 0,28s, en een klik op de balk die
           nog in beeld is telt gewoon, zoals altijd. Een klok en geen
           transitionend, want zonder animaties (systeeminstelling) komt die nooit. */
        if (show) {
          if (inertKlok) { clearTimeout(inertKlok); inertKlok = null; }
          if (bar.inert) { bar.inert = false; }
        } else if (!bar.inert && !inertKlok) {
          inertKlok = setTimeout(function () {
            inertKlok = null;
            if (!bar.classList.contains('is-visible')) { bar.inert = true; }
          }, 300);
        }
      };
      window.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(updateSticky);
      }, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();

      // Hide the bar outright while the cart drawer is open (body gets
      // `cart-locked`) so it never shows through the 45%-opaque scrim.
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          bar.style.visibility = document.body.classList.contains('cart-locked') ? 'hidden' : '';
        }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }
  /* Home (Karan, 2 nov 2026, v356): de knop in de prijskaart legt een Key in de
     winkelwagen en opent de la, net als In winkelwagen op de productpagina.
     Daarna staat het mandje in de balk; met een lege wagen blijft het weg.
     Zonder JavaScript verstuurt het formulier gewoon (Shopify gaat dan naar de
     winkelwagenpagina). */
  Array.prototype.forEach.call(document.querySelectorAll('.price-atc'), function (knop) {
    var formulier = knop.form || null;
    var voegToe = function (e) {
      var idVeld = formulier && formulier.querySelector('[name="id"]');
      // In de winkel zonder variant: het formulier gewoon laten versturen.
      if (inWinkel && !(idVeld && idVeld.value)) { return; }
      if (e && e.preventDefault) { e.preventDefault(); }
      /* Loopt er al een toevoeging, dan niets doen: een dubbelklik legde anders
         twee Keys in de winkelwagen. De vlag gaat er op elk pad weer af. */
      if (knop.disabled || knop.getAttribute('aria-busy') === 'true') { return; }
      if (inWinkel) {
        knop.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idVeld.value, quantity: 1 })
        }).then(function (r) {
          if (!r.ok) { throw new Error('toevoegen mislukt'); }
          return r.json();
        }).then(function () {
          if (bijwerken()) {
            // Er loopt een + of - (een absoluut aantal): tel de nieuwe Key erbij, net als op de productpagina.
            naToevoegen = true;
            var nuQ = 0; winkelCart.forEach(function (l) { nuQ += l.qty; });
            saveCart([{ key: 'single', qty: nuQ + 1 }]);
          }
          haalWinkel(function () {
            knop.removeAttribute('aria-busy');
            if (nav) nav.classList.remove('is-open');
            openCart();
          });
        }).catch(function () {
          // lukt het niet, dan alsnog langs de winkelwagenpagina van de winkel
          knop.removeAttribute('aria-busy');
          window.location.href = winkelWortel() + '/cart';
        });
        return;
      }
      var cart = readCart();
      var line = null;
      cart.forEach(function (l) { if (l.key === 'single') line = l; });
      if (line) line.qty += 1;
      else cart.push({ key: 'single', qty: 1 });
      saveCart(cart);
      if (nav) nav.classList.remove('is-open');
      openCart();
    };
    if (formulier) { formulier.addEventListener('submit', voegToe); } else { knop.addEventListener('click', voegToe); }
  });

  /* Bij het laden het aantal in de balk uit de juiste bron halen. In de winkel
     alleen waar het mandje staat (productpagina, winkelwagen en home): elders is er
     geen badge en geen la, en was dit een overbodige aanvraag bij elke pagina. */
  if (inWinkel) {
    if (document.querySelector('.cart-btn')) { haalWinkel(renderCart); }
  } else { renderCart(); }
  /* Terug met de terugknop uit het back/forward-geheugen draait dit script niet
     opnieuw; dan stonden badge en la nog op de oude stand (bijvoorbeeld van voor
     een kortingscode in de kassa). Dus dan de winkelwagen opnieuw ophalen. */
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted && inWinkel && document.querySelector('.cart-btn')) { haalWinkel(renderCart); }
  });

  var stepBtns = Array.prototype.slice.call(document.querySelectorAll('.step-btn'));
  var stepImgs = Array.prototype.slice.call(document.querySelectorAll('.how-media img'));
  /* Vanaf 1100px staan de drie stappen naast elkaar en onder 860px als
     veegkaarten, allemaal open met hun eigen foto (styles.css, "How It
     Works en Next-Gen Tap Tech"); daar doet een klik niets. Daartussen
     (860-1099px) blijft het de uitklaplijst van altijd. De breekpunten
     hier horen gelijk te zijn aan die in de CSS. */
  var stapAllesOpen = window.matchMedia ? window.matchMedia('(min-width: 1100px), (max-width: 859.98px)') : null;
  var stapAria = function () {
    // Uitklaplijst: de uitleg van een stap is alleen zichtbaar als hij open is;
    // dat hoort een schermlezer ook te weten. Staat alles open, dan doet een
    // klik niets; dan zijn het gewone kaarten, ook voor de tabtoets.
    var alles = !!(stapAllesOpen && stapAllesOpen.matches);
    stepBtns.forEach(function (b) {
      if (alles) {
        b.removeAttribute('aria-expanded');
        b.setAttribute('tabindex', '-1');
      } else {
        b.setAttribute('aria-expanded', b.classList.contains('is-active') ? 'true' : 'false');
        b.removeAttribute('tabindex');
      }
    });
  };
  if (stepBtns.length) {
    stapAria();
    stepBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stapAllesOpen && stapAllesOpen.matches) { stapAria(); return; }
        var step = btn.getAttribute('data-step');
        stepBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        stepImgs.forEach(function (img) {
          // Staat er maar een foto, dan blijft die altijd staan: de stappen
          // wisselen dan alleen de tekst.
          img.classList.toggle('is-active', stepImgs.length < 2 || img.getAttribute('data-step') === step);
        });
        stapAria();
      });
    });
    if (stapAllesOpen) {
      if (stapAllesOpen.addEventListener) { stapAllesOpen.addEventListener('change', stapAria); }
      else if (stapAllesOpen.addListener) { stapAllesOpen.addListener(stapAria); }
    }
    /* Smaller dan 1100px staat niet elke stapfoto in beeld: tussen 860 en
       1100px alleen die van de open stap (de andere zijn display: none), in
       de carrousel liggen kaart 2 en 3 naast het scherm. Met loading="lazy"
       laden die pas als je de stap opent of erheen veegt. Komt de sectie in
       de buurt, dan laden ze alvast, zodat er meteen een foto staat. */
    var stapFotos = Array.prototype.slice.call(document.querySelectorAll('.how-steps--cols .how-shot img'));
    var stapSectie = document.querySelector('.how-steps--cols');
    if (stapFotos.length && stapSectie && 'IntersectionObserver' in window) {
      var fotoKijker = new IntersectionObserver(function (items) {
        if (items.some(function (it) { return it.isIntersecting; })) {
          stapFotos.forEach(function (img) { img.loading = 'eager'; });
          fotoKijker.disconnect();
        }
      }, { rootMargin: '600px 0px' });
      fotoKijker.observe(stapSectie);
    }
    /* Onder 860px zijn de stappen veegkaarten (styles.css, "Onder 860px:
       veegcarrousel"). De stippen eronder tonen welke kaart vooraan staat;
       een tik op een stip schuift er vloeiend naartoe, vanaf de huidige stand
       en met dezelfde ease-out als de functietabjes (schuif). Vanaf 860px
       verbergt de CSS de stippen. */
    var stapNl = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase() === 'nl';
    Array.prototype.forEach.call(document.querySelectorAll('.how-steps--cols .step-list'), function (lijst) {
      var kaarten = Array.prototype.slice.call(lijst.querySelectorAll('.how-col'));
      if (kaarten.length < 2) { return; }
      var stippen = document.createElement('div');
      stippen.className = 'how-stippen';
      var anim = 0;
      var stop = function () { if (anim) { cancelAnimationFrame(anim); anim = 0; lijst.style.scrollSnapType = ''; } };
      // de lijn waarop een kaart vooraan staat: de linkerrand binnen de opvulling
      var rand = function () { return lijst.getBoundingClientRect().left + parseFloat(getComputedStyle(lijst).paddingLeft); };
      var naar = function (i) {
        stop();
        var van = lijst.scrollLeft;
        var doel = Math.max(0, Math.min(van + kaarten[i].getBoundingClientRect().left - rand(), lijst.scrollWidth - lijst.clientWidth));
        var afstand = doel - van;
        if (Math.abs(afstand) < 1) { return; }
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { lijst.scrollLeft = doel; return; }
        var duur = 520;
        var begin = null;
        // Tijdens het schuiven geen snap, anders trekt de browser elke tussenstand naar een kaart.
        lijst.style.scrollSnapType = 'none';
        var stap = function (nu) {
          if (begin === null) { begin = nu; }
          var t = Math.min(1, (nu - begin) / duur);
          lijst.scrollLeft = van + afstand * (1 - Math.pow(1 - t, 3));
          if (t < 1) { anim = requestAnimationFrame(stap); } else { anim = 0; lijst.style.scrollSnapType = ''; }
        };
        anim = requestAnimationFrame(stap);
      };
      kaarten.forEach(function (kaart, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (stapNl ? 'Stap ' : 'Step ') + (i + 1));
        b.addEventListener('click', function () { naar(i); });
        stippen.appendChild(b);
      });
      lijst.parentNode.insertBefore(stippen, lijst.nextSibling);
      // Welke kaart vooraan staat: helemaal naar rechts is dat de laatste (die
      // komt niet tot op de rand), anders de kaart die het dichtst bij de rand staat.
      var vooraan = function () {
        if (lijst.scrollLeft + lijst.clientWidth >= lijst.scrollWidth - 2) { return kaarten.length - 1; }
        var r = rand();
        var best = 0;
        var kleinste = Infinity;
        kaarten.forEach(function (kaart, i) {
          var d = Math.abs(kaart.getBoundingClientRect().left - r);
          if (d < kleinste) { kleinste = d; best = i; }
        });
        return best;
      };
      var teken = function () {
        var v = vooraan();
        Array.prototype.forEach.call(stippen.children, function (b, i) {
          b.classList.toggle('is-active', i === v);
          if (i === v) { b.setAttribute('aria-current', 'step'); } else { b.removeAttribute('aria-current'); }
        });
      };
      var wacht = 0;
      lijst.addEventListener('scroll', function () {
        if (!wacht) { wacht = requestAnimationFrame(function () { wacht = 0; teken(); }); }
      }, { passive: true });
      // Zelf vegen of scrollen tijdens het schuiven: de hand wint.
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (soort) { lijst.addEventListener(soort, stop, { passive: true }); });
      teken();
      window.addEventListener('resize', teken);
    });
  }

  /* Features: acht tabbladen met elk een video op de achtergrond.

     De video's staan bewust zonder src en zonder poster in de HTML. Acht
     autoplay-video's zouden anders bij het openen van de pagina samen tientallen
     megabytes ophalen. Ze worden hier pas ingeladen vlak voordat de sectie in
     beeld komt, en alleen die van het zichtbare tabblad speelt -- de rest staat
     stil en is niet eens opgehaald. */
  var featWrap = document.querySelector('[data-feat]');
  if (featWrap) {
    var featPills = Array.prototype.slice.call(featWrap.querySelectorAll('[data-feat-tab]'));
    var featPanels = Array.prototype.slice.call(featWrap.querySelectorAll('[data-feat-panel]'));
    var featZichtbaar = false;

    /* Zodra de sectie in zicht komt: alle achtergrondfoto's ophalen. Ze staan
       op `lazy` in een paneel dat `hidden` is, en zo'n paneel heeft geen plek
       op de pagina -- dus komt de foto voor de browser nooit in de buurt van
       het scherm en begint hij pas te laden als je het tabblad aanklikt. Tot
       dat moment zie je het podium, en dat is bijna zwart. */
    var stillsGehaald = false;
    var haalStills = function () {
      if (stillsGehaald) { return; }
      stillsGehaald = true;
      Array.prototype.forEach.call(featWrap.querySelectorAll('.feat-still'), function (img) {
        if (img.getAttribute('loading') === 'lazy') {
          img.setAttribute('loading', 'eager');
          /* Lage prioriteit: de bezoeker kijkt nu naar het eerste paneel, deze
             zeven zijn voor straks. */
          img.setAttribute('fetchpriority', 'low');
        }
        /* Ook los opvragen: een browser die het verborgen element blijft
           overslaan, heeft het adres dan toch in de cache staan. */
        var bron = img.getAttribute('src');
        if (bron) { var voor = new Image(); voor.src = bron; }
      });
    };

    var vulVideo = function (video) {
      if (!video || video.getAttribute('src')) { return; }
      // Eerst de foto forceren, dan pas de video. Met loading="lazy" beginnen ze
      // anders tegelijk, en dan zie je het donkere kader tot de video er is --
      // terwijl de foto twintig keer lichter is en er dus veel eerder staat.
      var still = video.parentElement ? video.parentElement.querySelector('.feat-still') : null;
      if (still && still.getAttribute('loading') === 'lazy') {
        still.setAttribute('loading', 'eager');
        still.setAttribute('fetchpriority', 'high');
      }
      /* Pas zichtbaar maken zodra er echt beeld IS -- dus bij `playing`, niet bij
         `loadeddata`. Dat laatste betekent alleen dat de eerste gegevens binnen
         zijn; een <video> tekent zich dan nog als zwart vlak en dat legde zich
         over de foto. Speelt hij nooit, dan blijft de foto staan, en dat is het
         beeld waaruit de video is gemaakt. */
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      video.setAttribute('src', video.getAttribute('data-src'));
    };

    var speelActieve = function () {
      featPanels.forEach(function (paneel) {
        var video = paneel.querySelector('.feat-video');
        if (!video) { return; }
        if (paneel.hasAttribute('hidden') || !featZichtbaar) {
          if (!video.paused) { video.pause(); }
          return;
        }
        vulVideo(video);
        var poging = video.play();
        // Safari geeft een promise terug die kan afketsen als de gebruiker
        // bewegende beelden heeft uitgezet; dan blijft de poster staan.
        if (poging && poging.catch) { poging.catch(function () {}); }
      });
    };

    /* De balk schuift met een eigen animatie in plaats van met scrollTo smooth.
       Die van de browser duurt ~250ms met een vaste curve en voelt mechanisch;
       een swipe gaat snel weg en rolt zacht uit. Vandaar een halve seconde met
       een ease-out: de eerste helft van de afstand is in een derde van de tijd
       afgelegd, de rest bolt langzaam af. */
    var schuifTimer = null;
    var schuif = function (balk, doel) {
      if (schuifTimer) { cancelAnimationFrame(schuifTimer); schuifTimer = null; }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        balk.scrollLeft = doel;
        return;
      }
      var van = balk.scrollLeft;
      var afstand = doel - van;
      if (!afstand) { return; }
      var duur = 520;
      var begin = null;
      var stap = function (nu) {
        if (begin === null) { begin = nu; }
        var t = Math.min(1, (nu - begin) / duur);
        var e = 1 - Math.pow(1 - t, 3);
        balk.scrollLeft = van + afstand * e;
        if (t < 1) { schuifTimer = requestAnimationFrame(stap); } else { schuifTimer = null; }
      };
      schuifTimer = requestAnimationFrame(stap);
    };

    var kies = function (n) {
      featPills.forEach(function (p) {
        var aan = p.getAttribute('data-feat-tab') === String(n);
        p.classList.toggle('is-active', aan);
        // Knoppen die een keuze aangeven, geen echte tablist: dus aria-pressed.
        p.setAttribute('aria-pressed', aan ? 'true' : 'false');
        // Niet het gekozen tabblad in beeld schuiven maar het volgende: zo zie je
        // altijd dat er nog meer features rechts staan, in plaats van dat de balk
        // stil blijft staan zodra je de laatste zichtbare aantikt.
        if (aan) {
          // Zelf uitrekenen in plaats van scrollIntoView: die beslist met
          // 'nearest' soms dat schuiven niet nodig is, en springt zonder
          // behavior in een keer -- wat leest als een storing. Doel is dat het
          // volgende tabblad net binnen de rand valt, zodat zichtbaar is dat er
          // meer staat.
          var balk = p.parentElement;
          var volgende = p.nextElementSibling || p;
          var over = (volgende.offsetLeft + volgende.offsetWidth) - (balk.scrollLeft + balk.clientWidth) + 14;
          var tekort = balk.scrollLeft - volgende.offsetLeft + 14;
          var doel = over > 0 ? balk.scrollLeft + over : (tekort > 0 ? balk.scrollLeft - tekort : null);
          if (doel !== null) { schuif(balk, Math.max(0, doel)); }
        }
      });
      featPanels.forEach(function (paneel) {
        paneel.hidden = paneel.getAttribute('data-feat-panel') !== String(n);
        paneel.classList.toggle('is-active', !paneel.hidden);
      });
      speelActieve();
    };

    featPills.forEach(function (p) {
      p.addEventListener('click', function () { kies(p.getAttribute('data-feat-tab')); });
    });

    if ('IntersectionObserver' in window) {
      var featKijker = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          featZichtbaar = e.isIntersecting;
          if (featZichtbaar) { haalStills(); }
          speelActieve();
        });
      }, { rootMargin: '200px 0px' });
      featKijker.observe(featWrap);
    } else {
      featZichtbaar = true;
      haalStills();
      speelActieve();
    }
  }


  var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (els.length && !reduceMotion && 'IntersectionObserver' in window) {
    els.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity .8s cubic-bezier(.16,.8,.24,1), transform .8s cubic-bezier(.16,.8,.24,1)';
    });
    var delivered = false;
    var io = new IntersectionObserver(function (entries) {
      delivered = true;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'none';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });

    /* Wie in een sprong langs een blok gaat -- via een ankerlink, of doordat de
       browser de scrollpositie herstelt -- laat de waarnemer niets merken: het
       blok was eerst niet in beeld en is dat daarna nog steeds niet. Zonder dit
       vangnet blijft zo'n blok voorgoed onzichtbaar. */
    var wacht = false;
    var haalIn = function () {
      wacht = false;
      var rest = [];
      els.forEach(function (el) {
        if (el.style.opacity === '1') { return; }
        if (el.getBoundingClientRect().top < window.innerHeight * 0.94) {
          el.style.opacity = '1';
          el.style.transform = 'none';
          io.unobserve(el);
        } else { rest.push(el); }
      });
      els = rest;
      if (!els.length) { window.removeEventListener('scroll', opScroll); }
    };
    var opScroll = function () {
      if (wacht) { return; }
      wacht = true;
      window.requestAnimationFrame(haalIn);
    };
    window.addEventListener('scroll', opScroll, { passive: true });
    window.addEventListener('resize', opScroll, { passive: true });

    var armWatchdog = function () {
      setTimeout(function () {
        if (!delivered) {
          els.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
          io.disconnect();
        }
      }, 1500);
    };
    if (document.visibilityState === 'visible') {
      armWatchdog();
    } else {
      document.addEventListener('visibilitychange', function onVis() {
        if (document.visibilityState === 'visible') {
          document.removeEventListener('visibilitychange', onVis);
          armWatchdog();
        }
      });
    }
  }
})();

/* Toetsenbord of aanwijzer? Een paar plekken zetten de focus zelf ergens neer:
   de la, de pijlen van de galerij en de persona-rail, het mobiele menu. Dat mag
   alleen als de focus er via het toetsenbord kwam. Na een klik of tik bleef hij
   anders op een knop staan die Spatie of Enter daarna opnieuw indrukt (een
   extra Key in de winkelwagen, een foto terug), en Safari tekent er misschien
   een rand omheen. MotionToets() zegt of de huidige focus via een toets kwam.
   Dit blok luistert alleen en houdt nooit iets tegen. Het staat hier en niet
   bovenaan (daar staat bewust alleen de herlaadhulp); de galerij en de la
   erboven vragen het pas bij een klik of toets, als dit allang klaarstaat. */
window.MotionToets = (function () {
  var perToets = false;   // de laatste invoer was een toets
  var toetsFocus = false; // de huidige focus kwam er via een toets
  var terugInVenster = false;
  document.addEventListener('keydown', function (e) {
    // Alleen een modificatietoets (Alt voor Alt+Tab, Cmd, Shift) telt niet.
    if (/^(Shift|Control|Alt|AltGraph|Meta|OS|CapsLock|Fn)$/.test(String(e.key))) { return; }
    perToets = true;
    terugInVenster = false;
  }, true);
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (soort) {
    document.addEventListener(soort, function () { perToets = false; toetsFocus = false; terugInVenster = false; }, { capture: true, passive: true });
  });
  /* Wie naar een ander venster gaat en terugkomt, krijgt van de browser de oude
     focus terug. Dat zegt niets over hoe die er kwam, dus dan blijft het oordeel
     staan: een aangeklikte knop wordt zo geen toetsenbordfocus. */
  window.addEventListener('blur', function () { terugInVenster = true; });
  document.addEventListener('focusin', function () {
    if (terugInVenster) { terugInVenster = false; return; }
    toetsFocus = perToets;
  }, true);
  return function () { return toetsFocus; };
})();

/* Persona-rail: pijlen vanaf desktop. De rail zelf is CSS; dit regelt alleen het
   scrollen per tegel en verbergt een pijl zodra je aan dat uiteinde staat. */
(function () {
  var wrap = document.querySelector('.lifestyle-rail');
  if (!wrap) return;
  var rail = wrap.querySelector('.lifestyle-grid');
  var prev = wrap.querySelector('.life-arrow-prev');
  var next = wrap.querySelector('.life-arrow-next');
  if (!rail || !prev || !next) return;

  var stap = function (richting) {
    var tegel = rail.querySelector('.life-tile');
    // een kaart plus de tussenruimte van de rail (op home 20px sinds v357, elders 16px)
    var tussen = parseFloat(window.getComputedStyle(rail).columnGap) || 16;
    var afstand = tegel ? (tegel.offsetWidth + tussen) : Math.round(rail.clientWidth * 0.8);
    rail.scrollBy({ left: richting * afstand, behavior: 'smooth' });
  };
  prev.addEventListener('click', function () { stap(-1); });
  next.addEventListener('click', function () { stap(1); });

  var sync = function () {
    var max = rail.scrollWidth - rail.clientWidth;
    var begin = rail.scrollLeft <= 2;
    var eind = rail.scrollLeft >= max - 2;
    // Net als bij de galerij: verdwijnt de pijl met de focus, dan naar de andere,
    // en alleen als die focus er via het toetsenbord kwam.
    var naar = null;
    if (window.MotionToets && window.MotionToets()) {
      naar = (begin && document.activeElement === prev) ? next : ((eind && document.activeElement === next) ? prev : null);
    }
    prev.hidden = begin;
    next.hidden = eind;
    if (naar && !naar.hidden) { naar.focus({ preventScroll: true }); }
  };
  rail.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();

/* Productpagina: het uitklapblok met reviews en de vragen onder het koopblok.
   Beide zijn eenvoudige open/dicht-schakelaars; de opmaak zit in de CSS. */
(function () {
  var revs = document.querySelector('[data-revs]');
  if (revs) {
    var revsBtn = revs.querySelector('.hi-revs-btn');
    if (revsBtn) {
      revsBtn.addEventListener('click', function () { revs.classList.toggle('is-open'); });
    }
  }
  /* Een vraag tegelijk open, precies zoals het FAQ-blok verderop: opent er een,
     dan gaan de andere dicht. Bewust zonder eigen scrollcorrectie: die hield de
     aangetikte vraag op zijn plek door de hele pagina te verschuiven, en dat
     voelde als verspringen (Karan). Zo gaat het natuurlijk, net als bij de FAQ. */
  Array.prototype.slice.call(document.querySelectorAll('.hi-acc-q')).forEach(function (btn) {
    var item = btn.parentElement;
    btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      Array.prototype.slice.call(item.parentElement.children).forEach(function (ander) {
        if (!ander.classList.contains('hi-acc-item')) { return; }
        ander.classList.remove('is-open');
        var knop = ander.querySelector('.hi-acc-q');
        if (knop) { knop.setAttribute('aria-expanded', 'false'); }
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  /* Hier stond een tweede galerijhandler uit de tijd voor het karrousel. Die
     zocht '.hi-gallery-main img', wat sindsdien de EERSTE dia van het karrousel
     is -- elke klik op een miniatuur overschreef dus de studiofoto. Het
     karrousel hierboven regelt de miniaturen, de pijlen en het hoofdbeeld al. */
})();

/* Onthoud de huidige pagina zodra iemand naar de landenlijst klikt, zodat hij
   daar na zijn keuze naar terugkeert. Een delegated listener in de capture-fase,
   dus het werkt ook voor links die pas later in de pagina komen. */
document.addEventListener('click', function (e) {
  var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
  if (!a) { return; }
  if ((a.getAttribute('href') || '').indexOf('locations') === -1) { return; }
  if (window.location.pathname.indexOf('locations') > -1) { return; }
  try { window.sessionStorage.setItem('motionKeyTerug', window.location.pathname + window.location.search); } catch (err) {}
}, true);

/* Land van de bezoeker — één bron voor de footer, de landkiezer en de
   bezorgschatting, zodat die drie nooit uit elkaar kunnen lopen.

   Volgorde: eigen keuze op de Locations-pagina > GeoIP > taal/tijdzone.
   De werkdagen per land komen uit de verzendzones in Shopify
   (Settings -> Shipping and delivery). Verandert daar iets, pas ZONES hier aan.
   Een land dat we niet bezorgen komt hier niet voor; dan tonen we bewust niets. */
window.MotionLand = (function () {
  var KEUZE = 'motionKeyLand';   // door de bezoeker gekozen land
  var GEO = 'motionKeyGeo';      // gedetecteerd land, 24 uur geldig
  var TIK = 'motionKeyLandTik';  // land van een tik op de landenpagina, vanaf v297

  // Alle 27 landen waar we naartoe verzenden, met hun levertijd in werkdagen.
  var LANDEN = [
    { code: 'AT', en: 'Austria',        nl: 'Oostenrijk',         regio: 'eu', dagen: [3, 6] },
    { code: 'BE', en: 'Belgium',        nl: 'België',             regio: 'eu', dagen: [1, 3] },
    { code: 'HR', en: 'Croatia',        nl: 'Kroatië',            regio: 'eu', dagen: [3, 6] },
    { code: 'CY', en: 'Cyprus',         nl: 'Cyprus',             regio: 'eu', dagen: [4, 7] },
    { code: 'CZ', en: 'Czechia',        nl: 'Tsjechië',           regio: 'eu', dagen: [3, 6] },
    { code: 'DK', en: 'Denmark',        nl: 'Denemarken',         regio: 'eu', dagen: [3, 6] },
    { code: 'EE', en: 'Estonia',        nl: 'Estland',            regio: 'eu', dagen: [4, 7] },
    { code: 'FI', en: 'Finland',        nl: 'Finland',            regio: 'eu', dagen: [4, 7] },
    { code: 'FR', en: 'France',         nl: 'Frankrijk',          regio: 'eu', dagen: [2, 4] },
    { code: 'DE', en: 'Germany',        nl: 'Duitsland',          regio: 'eu', dagen: [2, 4] },
    { code: 'GR', en: 'Greece',         nl: 'Griekenland',        regio: 'eu', dagen: [4, 7] },
    { code: 'IE', en: 'Ireland',        nl: 'Ierland',            regio: 'eu', dagen: [3, 6] },
    { code: 'IT', en: 'Italy',          nl: 'Italië',             regio: 'eu', dagen: [3, 6] },
    { code: 'LV', en: 'Latvia',         nl: 'Letland',            regio: 'eu', dagen: [4, 7] },
    { code: 'LT', en: 'Lithuania',      nl: 'Litouwen',           regio: 'eu', dagen: [4, 7] },
    { code: 'LU', en: 'Luxembourg',     nl: 'Luxemburg',          regio: 'eu', dagen: [2, 4] },
    { code: 'MT', en: 'Malta',          nl: 'Malta',              regio: 'eu', dagen: [4, 7] },
    { code: 'NL', en: 'Netherlands',    nl: 'Nederland',          regio: 'eu', dagen: [1, 3], enIn: 'the Netherlands' },
    { code: 'PL', en: 'Poland',         nl: 'Polen',              regio: 'eu', dagen: [3, 6] },
    { code: 'PT', en: 'Portugal',       nl: 'Portugal',           regio: 'eu', dagen: [3, 6] },
    { code: 'SK', en: 'Slovakia',       nl: 'Slowakije',          regio: 'eu', dagen: [3, 6] },
    { code: 'SI', en: 'Slovenia',       nl: 'Slovenië',           regio: 'eu', dagen: [3, 6] },
    { code: 'ES', en: 'Spain',          nl: 'Spanje',             regio: 'eu', dagen: [3, 6] },
    { code: 'SE', en: 'Sweden',         nl: 'Zweden',             regio: 'eu', dagen: [3, 6] },
    { code: 'GB', en: 'United Kingdom', nl: 'Verenigd Koninkrijk', regio: 'eu', dagen: [3, 5], enIn: 'the United Kingdom', nlIn: 'het Verenigd Koninkrijk', enKort: 'the UK', nlKort: 'het VK' },
    { code: 'US', en: 'United States',  nl: 'Verenigde Staten',   regio: 'am', dagen: [5, 8], enIn: 'the United States', nlIn: 'de Verenigde Staten', enKort: 'the US', nlKort: 'de VS' },
    { code: 'AU', en: 'Australia',      nl: 'Australië',          regio: 'ap', dagen: [8, 14] }
  ];

  var OP_CODE = {};
  for (var i = 0; i < LANDEN.length; i++) { OP_CODE[LANDEN[i].code] = LANDEN[i]; }

  var isNL = function () { return document.documentElement.lang === 'nl'; };

  var lees = function (sleutel) {
    try { return JSON.parse(localStorage.getItem(sleutel) || 'null'); } catch (e) { return null; }
  };
  var schrijf = function (sleutel, waarde) {
    try { localStorage.setItem(sleutel, JSON.stringify(waarde)); } catch (e) {}
  };

  var netjes = function (code) {
    var c = String(code || '').trim().toUpperCase();
    return OP_CODE[c] ? c : '';
  };

  /* Alleen in de webshop. Maakt het terugpad veilig voor het localization-
     formulier: nooit de landenpagina zelf, nooit Shopify's eigen country-,
     currency- of locale-parameter (ook niet gecodeerd; een ?country= in het
     terugpad draait de keuze meteen weer terug), en altijd in de taal van DEZE
     pagina, want het formulier zet het land voor het taalpad van deze pagina.
     Andere paden (account, checkout) blijven zoals ze zijn. */
  var TAALPADEN = /^\/(products|collections|pages|policies|blogs|search|cart)(\/|$)/;
  var schoonTerug = function (p) {
    var mc = window.MotionCart;
    if (!p || !mc || !mc.roots || !mc.roots.length) { return p; }
    var hash = '', zoek = '', i;
    var h = p.indexOf('#');
    if (h > -1) { hash = p.slice(h); p = p.slice(0, h); }
    var q = p.indexOf('?');
    if (q > -1) { zoek = p.slice(q + 1); p = p.slice(0, q); }
    var delen = zoek ? zoek.split('&') : [];
    var blijf = [];
    for (i = 0; i < delen.length; i++) {
      var k = delen[i].split('=')[0];
      try { k = decodeURIComponent(k.replace(/\+/g, ' ')); } catch (e) {}
      k = k.toLowerCase();
      if (k && k !== 'country' && k !== 'currency' && k !== 'locale') { blijf.push(delen[i]); }
    }
    var kaal = p;
    for (i = 0; i < mc.roots.length; i++) {
      var w = String(mc.roots[i] || '/').replace(/\/+$/, '');
      if (w && (kaal === w || kaal.indexOf(w + '/') === 0)) { kaal = kaal.slice(w.length) || '/'; break; }
    }
    if (/^\/pages\/locations\/?$/.test(kaal)) { return ''; }
    var hier = String(mc.root || '/').replace(/\/+$/, '');
    if (kaal === '/') { p = hier || '/'; }
    else if (TAALPADEN.test(kaal)) { p = hier + kaal; }
    return p + (blijf.length ? '?' + blijf.join('&') : '') + hash;
  };

  var uitLocale = function () {
    var talen = navigator.languages || [navigator.language || ''];
    for (var i = 0; i < talen.length; i++) {
      var m = /-([A-Za-z]{2})\b/.exec(talen[i] || '');
      if (m && netjes(m[1])) { return m[1].toUpperCase(); }
    }
    var tz = '';
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    var TZ = {
      'Europe/Brussels': 'BE', 'Europe/Amsterdam': 'NL', 'Europe/Luxembourg': 'LU',
      'Europe/Berlin': 'DE', 'Europe/Paris': 'FR', 'Europe/London': 'GB',
      'Europe/Dublin': 'IE', 'Europe/Madrid': 'ES', 'Europe/Rome': 'IT',
      'Europe/Lisbon': 'PT', 'Europe/Vienna': 'AT', 'Europe/Copenhagen': 'DK',
      'Europe/Stockholm': 'SE', 'Europe/Warsaw': 'PL', 'Europe/Prague': 'CZ',
      'Europe/Bratislava': 'SK', 'Europe/Ljubljana': 'SI', 'Europe/Zagreb': 'HR',
      'Europe/Helsinki': 'FI', 'Europe/Athens': 'GR', 'Europe/Tallinn': 'EE',
      'Europe/Riga': 'LV', 'Europe/Vilnius': 'LT', 'Europe/Malta': 'MT',
      'Asia/Nicosia': 'CY', 'Europe/Nicosia': 'CY',
      'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Brisbane': 'AU',
      'Australia/Perth': 'AU', 'Australia/Adelaide': 'AU'
    };
    if (netjes(TZ[tz])) { return TZ[tz]; }
    // Amerikaanse tijdzones zijn er te veel om op te sommen; het voorvoegsel volstaat.
    if (/^America\//.test(tz)) { return 'US'; }
    return '';
  };

  var haal = function (url, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) { ctrl.abort(); } }, ms);
    return fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { clearTimeout(timer); return r.ok ? r.json() : null; })
      .catch(function () { clearTimeout(timer); return null; });
  };

  var luisteraars = [];
  var huidig = null;

  var meld = function (code) {
    huidig = code;
    for (var i = 0; i < luisteraars.length; i++) {
      try { luisteraars[i](code); } catch (e) {}
    }
  };

  /* Oostenrijk is Shopify's eigen terugvalland: een aanvraag die Shopify niet
     kan plaatsen (geen of een verouderd localization-cookie voor dit taalpad,
     geen bruikbare taalheader) krijgt AT. Daarom alleen AT, geen enkel ander
     land: elk ander land heeft Shopify echt zo bepaald. Staat er AT terwijl de
     bezoeker op de landenpagina zelf een ander euroland koos, dan tonen we zijn
     keuze en zetten we Shopify op de achtergrond recht, met dezelfde deeplink
     als bij een tik (een keer per paginalading). Alleen eurolanden: de bedragen
     op de pagina staan dan al in de goede munt. Op de landenpagina zelf alleen
     de weergave, zodat de rand om de kaart en de footer daar hetzelfde land
     tonen als elders; de aanvraag niet, want daar tikt de bezoeker en die mag
     niet met zijn tik racen. Niet herladen en geen cookie schrijven.
     We vertrouwen alleen TIK, die vanaf v297 alleen een tik op de landenpagina
     schrijft. KEUZE niet: v293 t/m v295 schreven daar bij de terugknop ook het
     cookieland in. En alleen als Shopify's cookie AT zegt of ontbreekt: kent
     het cookie al een ander land, dan is er niets te herstellen.
     Bewust geaccepteerd: we kunnen niet zien of Shopify AT echt zo bepaalde
     (een Oostenrijks adres in de kassa, een link met ?country=AT, een echt
     Oostenrijks IP na een eerdere tik op een ander land). Dan wint die eerdere
     tik tot de bezoeker Oostenrijk tikt. */
  var EURO = ['BE', 'HR', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES'];
  var herstelKeuze = function () {
    if (!window.MotionCart) { return ''; }
    // Kent Shopify's cookie al een ander land dan AT, dan is er niets te herstellen.
    var koek = /(?:^|;\s*)localization=([^;]*)/.exec(document.cookie || '');
    var koekLand = koek ? String(koek[1]).trim().toUpperCase() : '';
    if (koekLand && koekLand !== 'AT') { return ''; }
    var keuze = netjes(lees(TIK));
    if (!keuze || keuze === 'AT' || EURO.indexOf(keuze) === -1) { return ''; }
    return keuze;
  };
  var herstelGestuurd = false;
  var stuurHerstel = function (code) {
    var wortels = window.MotionCart.roots || [];
    if (herstelGestuurd || !wortels.length || typeof fetch !== 'function') { return; }
    herstelGestuurd = true;
    for (var w = 0; w < wortels.length; w++) {
      var r = String(wortels[w] || '/').replace(/\/+$/, '');
      try {
        fetch((r || '/') + '?sections=motion-land-sync&country=' + encodeURIComponent(code), { credentials: 'same-origin', cache: 'no-store', keepalive: true })['catch'](function () {});
      } catch (err) {}
    }
  };
  // Geeft true als de regel geldt; de keuze staat dan in beeld en in MotionCart.
  var herstelBijAT = function () {
    var keuze = herstelKeuze();
    if (!keuze) { return false; }
    window.MotionCart.land = keuze;
    if (huidig !== keuze) { meld(keuze); }
    // Op de landenpagina alleen de weergave (zie hierboven).
    if (!document.querySelector('[data-land-keuze]')) { stuurHerstel(keuze); }
    return true;
  };

  var bepaal = function () {
    // 1. In de webshop bepaalt Shopify de markt: die stuurt zowel de valuta als
    //    de verzendzone aan. Dat is dus de waarheid, niet onze eigen opslag.
    //    Behalve Shopify's terugvalland AT naast een eigen keuze (zie hierboven).
    if (window.MotionCart && netjes(window.MotionCart.land)) {
      if (netjes(window.MotionCart.land) === 'AT' && herstelBijAT()) { return; }
      meld(netjes(window.MotionCart.land));
      return;
    }

    // 2. eigen keuze (statische site, waar geen Shopify achter zit)
    var keuze = netjes(lees(KEUZE));
    if (keuze) { meld(keuze); return; }

    // 3. gecacht detectieresultaat (24 uur). We bewaren de ruwe landcode, ook
    //    van een land waar we niet naartoe verzenden, zodat we niet elke keer
    //    opnieuw gaan zoeken.
    var cache = lees(GEO);
    if (cache && cache.code && (new Date().getTime() - cache.t) < 864e5) {
      meld(netjes(cache.code));
      return;
    }

    // 4. GeoIP. Niets tonen tot dit rond is, zodat er nooit kort een verkeerd
    //    land in beeld staat.
    if (typeof fetch !== 'function') { meld(uitLocale()); return; }
    var gevonden = function (ruw) {
      // Het land is bekend. Verzenden we er niet naartoe, dan is dat het
      // antwoord -- dan niet alsnog op de browsertaal terugvallen, want een
      // Engelse browser in Japan zegt niets over waar het pakket heen gaat.
      var ruwe = String(ruw).trim().toUpperCase();
      schrijf(GEO, { code: ruwe, t: new Date().getTime() });
      meld(netjes(ruwe));
    };
    haal('https://get.geojs.io/v1/ip/country.json', 2500).then(function (d) {
      var ruw = d && (d.country || d.country_code);
      if (ruw) { gevonden(ruw); return; }
      return haal('https://ipapi.co/json/', 2500).then(function (d2) {
        var ruw2 = d2 && (d2.country_code || d2.country);
        if (ruw2) { gevonden(ruw2); return; }
        // Beide diensten onbereikbaar: dan is de browsertaal het beste dat we hebben.
        meld(uitLocale());
      });
    });
  };

  bepaal();

  return {
    landen: LANDEN,
    /* Roept terug zodra het land bekend is (en meteen als dat al zo is).
       De code is leeg als we het land niet kennen of er niet naartoe verzenden. */
    bij: function (fn) {
      luisteraars.push(fn);
      if (huidig !== null) { try { fn(huidig); } catch (e) {} }
    },
    naam: function (code) {
      var l = OP_CODE[netjes(code)];
      if (!l) { return ''; }
      return isNL() ? l.nl : l.en;
    },
    /* Zelfde naam, maar zoals hij achter "in" hoort te staan. Een lijst schrijft
       "Netherlands", een zin schrijft "in the Netherlands". */
    naamIn: function (code) {
      var l = OP_CODE[netjes(code)];
      if (!l) { return ''; }
      if (isNL()) { return l.nlIn || l.nl; }
      return l.enIn || l.en;
    },
    /* Ingekorte vorm voor de bezorgregel op een telefoon. Alleen de twee namen
       die er anders overheen lopen hebben er een; de rest valt terug op de
       gewone zinsvorm. Een bezoeker ziet maar een land, dus deze afkorting komt
       nooit naast een voluit geschreven naam te staan. */
    naamKort: function (code) {
      var l = OP_CODE[netjes(code)];
      if (!l) { return ''; }
      if (isNL()) { return l.nlKort || l.nlIn || l.nl; }
      return l.enKort || l.enIn || l.en;
    },
    dagen: function (code) {
      var l = OP_CODE[netjes(code)];
      return l ? l.dagen : null;
    },
    /* Waar het pakket vandaan komt is voor de EU en het VK een geruststelling,
       maar buiten Europa roept "ons EU-magazijn" vooral vragen op over douane. */
    regio: function (code) {
      var l = OP_CODE[netjes(code)];
      return l ? l.regio : '';
    },
    /* Het pad waar de bezoeker vandaan kwam toen hij naar de landenlijst ging.
       Elke link daarheen legt het klaar; komt iemand rechtstreeks binnen, dan
       dient de verwijzende pagina als terugval en anders blijft hij staan. */
    terugpad: function () {
      var p = '';
      try { p = window.sessionStorage.getItem('motionKeyTerug') || ''; } catch (e) { p = ''; }
      if (!p && document.referrer) {
        try {
          var u = new URL(document.referrer, window.location.href);
          if (u.origin === window.location.origin && u.pathname !== window.location.pathname) {
            p = u.pathname + u.search;
          }
        } catch (e2) { p = ''; }
      }
      if (!p) { return ''; }
      // Alleen een pad op deze site: nooit "//ergens-anders" en nooit een
      // volledige URL, zodat hier geen vreemde bestemming in kan sluipen.
      if (p.indexOf('//') === 0 || p.indexOf(':') > -1) { return ''; }
      if (p.charAt(0) !== '/' && p.indexOf('.html') === -1) { return ''; }
      return schoonTerug(p);
    },
    /* Zet het land dat de bezoeker zelf koos. Wint vanaf nu van detectie. */
    kies: function (code) {
      var c = netjes(code);
      if (!c) { return false; }
      schrijf(KEUZE, c);
      // Alleen de tik op de landenpagina roept kies aan; op TIK vertrouwt het AT-herstel.
      schrijf(TIK, c);
      meld(c);
      return true;
    },
    /* Toont een land zonder het als keuze op te slaan. Voor de terugknop: het
       cookie zegt wat Shopify nu denkt, niet wat de bezoeker koos. */
    toon: function (code) {
      var c = netjes(code);
      if (!c) { return false; }
      meld(c);
      return true;
    },
    /* Geldt de AT-regel hierboven, dan staat de eigen keuze in beeld: true. */
    herstelAT: function () {
      return herstelBijAT();
    }
  };
})();

/* Terugknop: een pagina uit het back/forward-geheugen of uit de HTTP-cache
   draagt nog het land van voor een nieuwe keuze. Wijkt Shopify's land voor dit
   taalpad af, dan zetten we alleen de landweergave recht (bovenbalk, footer,
   bezorgschatting). Alleen binnen dezelfde valuta: anders stond er een nieuw
   land naast oude prijzen, en dan laten we de pagina liever zoals hij was.
   Niets herladen en geen cookie schrijven: de terugknop werkt zoals altijd. */
(function () {
  var landRecht = function () {
    var mc = window.MotionCart;
    if (!mc || !window.MotionLand) { return; }
    var koek = document.cookie || '';
    var m = /(?:^|;\s*)localization=([^;]*)/.exec(koek);
    var nu = m ? String(m[1]).trim().toUpperCase() : '';
    /* Nog AT in het cookie terwijl de bezoeker zelf een ander euroland koos: dat
       is Shopify's terugvalland, niet zijn keuze (zie MotionLand). Dan niet
       terugvallen op AT; de pagina toont zijn keuze. Alleen op een pagina in
       euro, net als de valutaregel hieronder. */
    if (nu === 'AT' && String(mc.currency || '').toUpperCase() === 'EUR' && window.MotionLand.herstelAT()) { return; }
    if (!nu || nu === String(mc.land || '').toUpperCase()) { return; }
    var v = /(?:^|;\s*)cart_currency=([^;]*)/.exec(koek);
    var munt = v ? String(v[1]).trim().toUpperCase() : '';
    if (!munt || munt !== String(mc.currency || '').toUpperCase()) { return; }
    // Alleen tonen, niet opslaan: de eigen keuze schrijft alleen een tik op de landenpagina.
    if (window.MotionLand.toon(nu)) { mc.land = nu; }
  };
  // Terug via de HTTP-cache: dezelfde pagina, maar een gewone lading.
  try {
    var nav = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type === 'back_forward') { landRecht(); }
  } catch (err) {}
  // Terug uit het back/forward-geheugen: het script draait niet opnieuw.
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) { landRecht(); }
  });
})();

/* Landkeuze op twee plekken: voluit in de footer, als landcode in de balk
   bovenaan. Allebei linken ze naar dezelfde landenpagina, zodat er maar een
   lijst met landen bestaat die kan verlopen. */
(function () {
  var voluit = document.querySelectorAll('[data-land-naam]');
  var kort = document.querySelectorAll('[data-land-code]');
  if ((!voluit.length && !kort.length) || !window.MotionLand) { return; }
  var nl = document.documentElement.lang === 'nl';
  var toon = function (el) {
    var wrap = el.closest ? el.closest('[data-land-link]') : null;
    if (wrap) { wrap.hidden = false; }
  };
  window.MotionLand.bij(function (code) {
    var naam = window.MotionLand.naam(code);
    var vraag = nl ? 'Kies je land' : 'Choose your location';
    for (var i = 0; i < voluit.length; i++) {
      // Zonder bekend land blijft de link staan, maar met een neutrale tekst —
      // hij is dan nog steeds de weg naar de landkiezer.
      voluit[i].textContent = naam || vraag;
      toon(voluit[i]);
    }
    for (var j = 0; j < kort.length; j++) {
      // In de balk is geen ruimte voor een landnaam. Kennen we het land niet,
      // dan blijft alleen de wereldbol staan; het label vertelt de rest.
      kort[j].textContent = code || '';
      var knop = kort[j].closest ? kort[j].closest('[data-land-link]') : null;
      if (knop) {
        knop.setAttribute('aria-label', naam ? (nl ? 'Land: ' + naam + '. Wijzigen' : 'Country: ' + naam + '. Change') : vraag);
        // De wereldbol is er alleen voor het geval we geen land kennen; naast
        // een landcode is hij overbodig. Via een klasse op de link, want een
        // SVG-element kent de hidden-eigenschap van HTML niet.
        knop.classList.toggle('is-land-bekend', !!code);
      }
      toon(kort[j]);
    }
  });
})();

/* De 27 kaarten op de landenpagina krijgen hun eigen vlag. Daar staat de
   volledige landnaam ernaast, dus er is geen verwarring mogelijk, en bij het
   zoeken in een lijst van 27 helpt een vlag het meest. */
(function () {
  var kaarten = document.querySelectorAll('.loc-card[data-code]');
  if (!kaarten.length) { return; }
  Array.prototype.forEach.call(kaarten, function (kaart) {
    var code = (kaart.getAttribute('data-code') || '').toLowerCase();
    if (!code) { return; }
    var img = document.createElement('img');
    img.className = 'land-vlag';
    img.width = 22; img.height = 16;
    img.alt = '';
    img.loading = 'lazy';
    img.setAttribute('aria-hidden', 'true');
    img.onerror = function () {
      if (img.parentNode) { img.parentNode.removeChild(img); }
      kaart.classList.remove('is-land-bekend');
    };
    img.src = 'https://cdn.shopify.com/static/images/flags/' + code + '.svg';
    kaart.insertBefore(img, kaart.firstChild);
    kaart.classList.add('is-land-bekend');
  });
})();

/* Landkiezer: een klik legt het land vast en stuurt je terug waar je vandaan kwam. */
(function () {
  var lijst = document.querySelector('[data-land-keuze]');
  if (!lijst || !window.MotionLand) { return; }

  /* Terug naar waar de bezoeker vandaan kwam. Blijven staan op een lijst van 27
     landen is een doodlopend eind: wie vanaf de productpagina zijn land aanpast
     wil de nieuwe bezorgdatum zien, niet zelf terugklikken.
     In het thema is elke kaart een verzendknop van het localization-formulier en
     laadt Shopify na het omzetten van de markt het pad uit dit verborgen veld.
     In de statische site is het een gewone link, en dan zetten we de bestemming
     zelf in de href. Dat is beter dan onderweg omleiden: middelklik en "openen
     in een nieuw tabblad" blijven zo werken, en zonder onthouden pad houden de
     kaarten hun eigen bestemming. */
  var terug = window.MotionLand.terugpad();
  if (terug) {
    /* Shopify's form-tag zet zelf ook een return_to. Beide velden krijgen
       hetzelfde pad, dan maakt het niet uit welke van de twee Shopify leest. */
    var formulier = lijst.closest ? lijst.closest('form') : null;
    var velden = formulier ? formulier.querySelectorAll('input[name="return_to"]') : document.querySelectorAll('[data-return]');
    for (var v = 0; v < velden.length; v++) { velden[v].value = terug; }
    var kaarten = lijst.querySelectorAll('.loc-card[href]');
    for (var i = 0; i < kaarten.length; i++) { kaarten[i].setAttribute('href', terug); }
  }

  /* aria-current vertelt een schermlezer welke kaart het huidige land is; de
     blauwe rand zie je alleen. 'false' in plaats van weghalen: betekent voor een
     schermlezer hetzelfde. */
  window.MotionLand.bij(function (code) {
    var actief = lijst.querySelector('.loc-card.is-current');
    if (actief) { actief.classList.remove('is-current'); actief.setAttribute('aria-current', 'false'); }
    if (!code) { return; }
    var kaart = lijst.querySelector('.loc-card[data-code="' + code + '"]');
    if (kaart) { kaart.classList.add('is-current'); kaart.setAttribute('aria-current', 'true'); }
  });

  /* Shopify onthoudt het land per taal (een cookie op / en een op /nl) en in
     de winkelwagen, en dit formulier zet alleen de taal van deze pagina. Dus
     laten we Shopify bij de tik op de achtergrond hetzelfde land ook voor elke
     taal zetten, met zijn eigen deeplink op een lege sectie-aanvraag (13
     bytes). Het formulier gaat gewoon meteen, net als altijd; keepalive laat
     die aanvragen afmaken ook als de pagina al wisselt. Wij schrijven zelf
     geen cookie. Op de statische site (geen MotionCart) gebeurt dit niet. */
  var wortels = (window.MotionCart && window.MotionCart.roots) || [];
  var lopend = [];
  lijst.addEventListener('click', function (e) {
    var kaart = e.target.closest ? e.target.closest('.loc-card') : null;
    if (!kaart) { return; }
    var code = kaart.getAttribute('data-code');
    if (!window.MotionLand.kies(code)) { return; }
    if (!wortels.length || typeof fetch !== 'function') { return; }
    try { window.sessionStorage.removeItem('motionKeyTerug'); } catch (err) {}
    // Tikt iemand snel nog een ander land, dan eerst de aanvragen van de vorige
    // tik afbreken, zodat die de nieuwe keuze niet alsnog overschrijven.
    for (var a = 0; a < lopend.length; a++) { try { lopend[a].abort(); } catch (err3) {} }
    lopend = [];
    for (var w = 0; w < wortels.length; w++) {
      var r = String(wortels[w] || '/').replace(/\/+$/, '');
      var opties = { credentials: 'same-origin', cache: 'no-store', keepalive: true };
      if (typeof AbortController !== 'undefined') {
        var ctrl = new AbortController();
        lopend.push(ctrl);
        opties.signal = ctrl.signal;
      }
      try {
        fetch((r || '/') + '?sections=motion-land-sync&country=' + encodeURIComponent(code), opties)['catch'](function () {});
      } catch (err2) {}
    }
  });
})();

/* Geschatte bezorging in het koopblok. Gebruikt hetzelfde land als de footer,
   dus wat de bezoeker in de landkiezer aanwijst, telt hier meteen mee. */
(function () {
  var el = document.querySelector('[data-delivery]');
  if (!el || !window.MotionLand) { return; }
  var waarde = el.querySelector('[data-delivery-date]');
  if (!waarde) { return; }

  var isNL = document.documentElement.lang === 'nl';
  /* "business days" en niet "working days": de Engelse versie wordt vooral
     gelezen door niet-moedertaalsprekers in de EU, en die kennen die term uit
     elke andere webshop. In het VK is hij ook gewoon correct, dus er hoeft niets
     per markt te wisselen. */
  var EENHEID = isNL ? 'werkdagen' : 'business days';
  var DAG = isNL ? ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
                 : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MND = isNL ? ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec']
                 : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* Belgische wettelijke feestdagen: dan verlaat er niets het magazijn en
     rijdt bpost niet. 26 december staat erbij omdat in vrijwel elk
     bestemmingsland dan ook niemand bezorgt. De bewegende dagen worden uit
     Pasen berekend, dus deze lijst veroudert niet en hoeft nooit bijgewerkt. */
  var paaszondag = function (jaar) {
    var a = jaar % 19, b = Math.floor(jaar / 100), c = jaar % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mnd = Math.floor((h + l - 7 * m + 114) / 31);
    return new Date(jaar, mnd - 1, ((h + l - 7 * m + 114) % 31) + 1);
  };
  var feestPerJaar = {};
  var feestdag = function (d) {
    var jaar = d.getFullYear();
    if (!feestPerJaar[jaar]) {
      var uit = {};
      var zet = function (x) { uit[x.getMonth() + '-' + x.getDate()] = true; };
      [[0, 1], [4, 1], [6, 21], [7, 15], [10, 1], [10, 11], [11, 25], [11, 26]]
        .forEach(function (v) { zet(new Date(jaar, v[0], v[1])); });
      var p = paaszondag(jaar);
      [1, 39, 50].forEach(function (n) {
        var x = new Date(p.getTime()); x.setDate(x.getDate() + n); zet(x);
      });
      feestPerJaar[jaar] = uit;
    }
    return !!feestPerJaar[jaar][d.getMonth() + '-' + d.getDate()];
  };

  /* Werkdagen zijn maandag tot en met vrijdag. Zo tellen bpost, DHL en PostNL
     hun transittijden, en zo staan de zonegetallen ook in de FAQ. Zaterdag
     telde hier eerder mee als reisdag, wat elke schatting een dag te vroeg
     maakte; zaterdag als BEZORGdag staat daar los van, zie kanBezorgen. */
  var reisdag = function (d) { var g = d.getDay(); return g >= 1 && g <= 5 && !feestdag(d); };
  var naDagen = function (van, aantal) {
    var r = new Date(van.getTime());
    var c = 0;
    while (c < aantal) { r.setDate(r.getDate() + 1); if (reisdag(r)) { c++; } }
    return r;
  };

  /* Bezorgd wordt er maandag tot en met vrijdag. Zaterdag valt af: bpost
     bezorgt dan alleen aan een afhaalpunt, en de vlag per land die dat regelde
     deed niets meer sinds de telling alleen werkdagen gebruikt. Maandag stond
     hier eerder buiten, met als reden dat koeriers dan de weekendachterstand
     wegwerken; maar bpost, PostNL en DHL noemen maandag gewoon als bezorgdag,
     en de uitsluiting leverde 52 keer per jaar per zone een eendagig label op
     in plaats van een reeks. */
  var kanBezorgen = function (d) {
    if (feestdag(d)) { return false; }
    var g = d.getDay();
    return g >= 1 && g <= 5;
  };
  var bezorgbaar = function (d) {
    var r = new Date(d.getTime());
    while (!kanBezorgen(r)) { r.setDate(r.getDate() + 1); }
    return r;
  };


  /* De begindatum is altijd de vroegst mogelijke dag. Daar wordt nooit aan
     geschoven: dat is juist het goede nieuws, en het verbergen ervan maakt de
     bezorging zonder reden trager dan ze is.
     Ook aan de einddatum wordt niet gerekend: hij valt waar de verzendtijd
     afloopt, en schuift alleen vooruit naar de eerstvolgende dag waarop in dat
     land daadwerkelijk bezorgd wordt.
     Valt een datum in het weekend, dan schuift hij door naar maandag; bij een
     bestelling laat in de week loopt het venster daardoor optisch op. Dat is de
     eerlijke uitkomst: de zones versmallen levert op meerdere besteldagen twee
     keer dezelfde datum op. */

  /* De regel toont een aantal werkdagen, niet een datum. De zone verschilt wel
     per land, dus Belgie leest 1-3 en Griekenland 4-7. Datums stonden er eerder
     wel, maar in het ontwerp van de productpagina staat een dagental. */
  /* De tweede regel van de trustbalk onder de koopknop. Staat daar nu de
     gratis verzending; die maakt plaats voor de bezorgtermijn zodra we het
     land weten en die termijn kort genoeg is om als belofte te lezen.
     Boven MAX_TRUST werkdagen -- de Verenigde Staten en Australie -- blijft de
     gratis verzending staan: een getal van 8 tot 14 pal onder de koopknop
     schrikt af in plaats van gerust te stellen. De exacte termijn staat voor
     die landen gewoon in de Verzending-accordeon. */
  var MAX_TRUST = 7;
  var leverEl = document.querySelector('[data-lever]');
  var leverTerug = leverEl ? leverEl.textContent : '';
  var leverEtiket = isNL ? 'GESCHATTE BEZORGING:' : 'ESTIMATED DELIVERY:';
  var leverDatumEl = leverEl ? leverEl.parentElement.querySelector('[data-lever-datum]') : null;

  /* De zone als twee echte datums. De begindatum is de vroegst mogelijke dag,
     de einddatum de dag waarop de verzendtijd afloopt; allebei schuiven ze door
     naar de eerstvolgende dag waarop in dat land ook echt bezorgd wordt.
     Hoofdletters omdat de hele balk in kapitalen staat en er geen
     text-transform op zit. */
  var datumEtiket = function (bereik, code) {
    /* Een keer de klok lezen en doorgeven: twee losse new Date()-aanroepen
       konden een reeks opleveren die op dezelfde dag viel maar op milliseconden
       verschilde, en dan stond er twee keer dezelfde datum met een streepje. */
    var nu = new Date();
    var van = bezorgbaar(naDagen(nu, bereik[0]));
    var tot = bezorgbaar(naDagen(nu, bereik[1]));
    var kort = function (d) { return (DAG[d.getDay()] + ' ' + d.getDate() + ' ' + MND[d.getMonth()]).toUpperCase(); };
    if (kort(van) === kort(tot)) { return kort(van); }
    return kort(van) + ' – ' + kort(tot);
  };
  var leverRij = leverEl ? leverEl.parentElement : null;
  var leverWissel = function (datum) {
    if (leverRij) {
      if (datum) { leverRij.classList.add('hi-lever--datum'); } else { leverRij.classList.remove('hi-lever--datum'); }
    }
  };

  var etiket = function (bereik) {
    return bereik[0] + '\u2013' + bereik[1] + ' ' + EENHEID;
  };

  // De landnaam staat in de regel zelf en is een link naar de kiezer, zodat een
  // verkeerde gok zichtbaar is en met een tap te corrigeren.
  var landEl = el.querySelector('[data-delivery-land]');
  // De korte variant staat op mobiel vooraan de regel en krijgt daarom de kale
  // landnaam; "het Verenigd Koninkrijk" hoort niet met een kleine letter te
  // beginnen.
  var landKortEl = el.querySelector('[data-delivery-land-kort]');

  /* Elke bestemming krijgt zijn eigen aantal werkdagen te zien, ook de Verenigde
     Staten (5-8) en Australie (8-14). Een eerlijke schatting doet het beter dan
     helemaal geen regel. */
  var euMagazijn = document.querySelectorAll('[data-eu-magazijn]');

  window.MotionLand.bij(function (code) {
    var bereik = window.MotionLand.dagen(code);
    /* Alleen in de Verenigde Staten laten we weg waar het pakket vandaan komt:
       daar roept "ons EU-magazijn" vooral vragen op over invoerrechten. Elders,
       Australie inbegrepen, is het gewoon een geruststelling. */
    var uitEU = String(code || '').toUpperCase() === 'US';
    Array.prototype.forEach.call(euMagazijn, function (r) { r.hidden = uitEU; });
    // Onbekend land of een land waar we niet naartoe verzenden: liever niets.
    if (!bereik) {
      el.hidden = true;
      if (leverEl) {
        leverEl.textContent = leverTerug;
        if (leverDatumEl) { leverDatumEl.setAttribute('hidden', ''); }
        leverWissel(false);
      }
      return;
    }
    if (landEl) { landEl.textContent = window.MotionLand.naamIn(code); }
    if (landKortEl) { landKortEl.textContent = window.MotionLand.naamKort(code); }
    waarde.textContent = etiket(bereik, code);
    if (leverEl) {
      var toonDatum = bereik[1] <= MAX_TRUST;
      leverEl.textContent = toonDatum ? leverEtiket : leverTerug;
      if (leverDatumEl) {
        if (toonDatum) {
          leverDatumEl.textContent = datumEtiket(bereik, code);
          leverDatumEl.removeAttribute('hidden');
        } else { leverDatumEl.setAttribute('hidden', ''); }
      }
      leverWissel(toonDatum);
    }
    el.hidden = false;
  });
})();

/* ---------------------------------------------------------------------------
   Doorverwijzing door een partner (Shopify Collabs).

   De link van een creator loopt via Shopify: die zet zijn code op de
   winkelwagen, en de pagina opent met ?dt_id=... Dat kenmerk laten we in de
   adresbalk staan, want daaraan herkent Collabs het bezoek. Wij kijken alleen
   in /cart.js welke code er echt op de wagen staat, en bevestigen die met een
   melding: bij elke nieuwe klik op een creatorlink (hoogstens één keer per
   bezoek), en als er later een andere code op de wagen staat. Gewoon
   rondkijken zonder link toont hem niet opnieuw. Een doorgestuurd of in
   Safari heropend adres heeft geen code op de wagen, dus dan beloven we niets.
   Wie de code alleen gehoord heeft, typt hem bij het afrekenen in -- voor
   Collabs telt dat net zo goed.
--------------------------------------------------------------------------- */
(function () {
  // Op de partnerkit hoort deze melding niet: daar komt de creator zelf.
  if (document.querySelector('.kit-inner')) { return; }

  var SLEUTEL = 'motionRef';
  var SESSIE = 'motionRefGetoond';
  var SESSIE_CODE = 'motionRefSessieCode';
  /* Uit de winkelinstelling "Partner pop-up memory (days)": hoe lang dit toestel
     onthoudt welke partnercode al bevestigd is, zodat gewoon rondkijken hem niet
     opnieuw toont. Een nieuwe klik op een creatorlink toont hem wel opnieuw. */
  var DAGEN = (window.MotionCart && parseInt(window.MotionCart.affiliateDays, 10)) || 30;
  var opWinkel = document.body.hasAttribute('data-shop');

  var isNL = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase() === 'nl';

  /* Geen naam van de creator in de kop. Een Collabs-link draagt alleen een
     kenmerk, en bij een lege winkelwagen is ook de code niet altijd uit te
     lezen. Een naam die maar soms klopt is slechter dan geen naam. */
  var W = isNL ? {
    kop: 'Je korting staat klaar',
    lead: 'Klik hieronder om je kortingscode in te wisselen.',
    knop: 'Korting inwisselen',
    sluit: 'Sluiten'
  } : {
    kop: 'Your discount is ready',
    lead: 'Click below to redeem your discount code.',
    knop: 'Redeem discount',
    sluit: 'Close'
  };

  /* Alleen letters, cijfers, streepje en liggend streepje: een kortingscode
     hoort er zo uit te zien, en zo komt er niets vreemds in de pagina terecht. */
  var netjes = function (s) {
    s = String(s || '').trim().toUpperCase();
    return /^[A-Z0-9_-]{2,40}$/.test(s) ? s : '';
  };

  /* Het record onthoudt alleen dat iemand via een partner kwam en welke code we
     al bevestigd hebben -- niet het Collabs-kenmerk zelf. */
  var lees = function () {
    try {
      var r = JSON.parse(localStorage.getItem(SLEUTEL) || 'null');
      if (!r || !r.viaWinkel) { return null; }
      if (Date.now() - r.tijd > DAGEN * 864e5) { localStorage.removeItem(SLEUTEL); return null; }
      return r;
    } catch (e) { return null; }
  };
  var bewaar = function (r) {
    try { localStorage.setItem(SLEUTEL, JSON.stringify(r)); } catch (e) {}
  };

  var viaLink = false;
  try { viaLink = !!new URLSearchParams(window.location.search).get('dt_id'); } catch (e) {}

  var r = lees();
  if (viaLink) {
    // Een nieuwe klik op een partnerlink: de termijn begint opnieuw.
    r = { viaWinkel: true, tijd: Date.now(), bevestigd: (r && r.bevestigd) || '' };
    bewaar(r);
  }
  if (!r) { return; }

  /* Hoogstens één keer per bezoek in de winkelwagen kijken. */
  var alInSessie = false;
  try { alInSessie = sessionStorage.getItem(SESSIE) === '1'; } catch (e) {}
  if (alInSessie && !viaLink) { return; }
  try { sessionStorage.setItem(SESSIE, '1'); } catch (e) {}
  /* Welke code is in dit bezoek al getoond? Zo komt hij bij een tweede klik op
     dezelfde link in hetzelfde bezoek niet nog eens. */
  var sessieCode = '';
  try { sessieCode = sessionStorage.getItem(SESSIE_CODE) || ''; } catch (e) {}

  /* Welke code heeft Shopify echt op de wagen gezet? De laatst toegevoegde staat
     achteraan. Op een lege wagen telt elke bewaarde code, anders alleen een die
     geldt voor wat erin ligt. */
  var codeVanWagen = function () {
    var werk = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) { throw new Error('status ' + res.status); }
        return res.json();
      })
      .then(function (c) {
        var l = (c && c.discount_codes) || [];
        for (var i = l.length - 1; i >= 0; i--) {
          var k = netjes(l[i] && l[i].code);
          if (k && (c.item_count === 0 || l[i].applicable !== false)) { return k; }
        }
        return '';
      })['catch'](function () { return ''; });
    var teLang = new Promise(function (klaar) { setTimeout(function () { klaar(''); }, 5000); });
    return Promise.race([werk, teLang]);
  };

  /* Het venster komt pas na een netwerkronde. Open het niet midden in een veeg
     of terwijl iemand typt, en niet over de open winkelwagen: wacht tot de
     pagina even stilstaat. */
  var bewogen = 0;
  var noteer = function () { bewogen = Date.now(); };
  window.addEventListener('scroll', noteer, { passive: true });
  window.addEventListener('touchmove', noteer, { passive: true });
  document.addEventListener('keydown', noteer, true);
  document.addEventListener('input', noteer, true);
  // Een tik telt ook: wie net op 'In winkelwagen' tikte, krijgt de la, niet de melding erover.
  document.addEventListener('pointerdown', noteer, true);
  var naRust = function (f) {
    if (document.body.classList.contains('cart-locked') || document.querySelector('.atc-btn[aria-busy="true"]')) { setTimeout(function () { naRust(f); }, 500); return; }
    var t = Date.now() - bewogen;
    if (t >= 600) { f(); } else { setTimeout(function () { naRust(f); }, 600 - t); }
  };

  var actiefSluit = null;

  /* De korting staat al op de wagen; de knop bevestigt alleen en sluit. */
  var toon = function (code) {
    r.bevestigd = code || r.bevestigd || '-';
    bewaar(r);
    try { sessionStorage.setItem(SESSIE_CODE, code || '-'); } catch (e) {}
    var wrap = document.createElement('div');
    wrap.className = 'ref-pop';
    wrap.innerHTML =
      '<div class="ref-scrim"></div>' +
      '<div class="ref-card" role="dialog" aria-modal="true" tabindex="-1" aria-labelledby="ref-kop" aria-describedby="ref-lead">' +
        '<button type="button" class="ref-close" aria-label="' + W.sluit + '">&times;</button>' +
        '<h2 class="ref-kop" id="ref-kop">' + W.kop + '</h2>' +
        '<p class="ref-lead" id="ref-lead">' + W.lead + '</p>' +
        (code ? '<div class="ref-code"><span>' + code + '</span></div>' : '') +
        '<button type="button" class="ref-knop">' + W.knop + '</button>' +
      '</div>';
    document.body.appendChild(wrap);

    /* Een venster dat de pagina afdekt hoort de pagina ook stil te zetten, en de
       focus hoort erin te beginnen. De focus gaat naar de kaart, niet naar de
       knop: wie net met spatie scrolde of in een veld typte, activeert zo niet
       per ongeluk de knop. Tab gaat gewoon naar de knoppen. */
    var focusVoor = document.activeElement;
    var scrollVoor = window.scrollY;
    document.body.classList.add('ref-vast');
    document.body.style.top = '-' + scrollVoor + 'px';
    var kaart = wrap.querySelector('.ref-card');
    try { kaart.focus({ preventScroll: true }); } catch (e) { kaart.focus(); }

    var sluit = function () {
      // Maar een keer: Escape, het kruisje en de knop kunnen elkaar kruisen.
      if (!wrap.parentNode) { return; }
      actiefSluit = null;
      wrap.remove();
      document.body.classList.remove('ref-vast');
      document.body.style.top = '';
      /* Direct terug naar waar de bezoeker stond. De stylesheet scrolt zacht
         (html { scroll-behavior: smooth }), en dan gleed de pagina zichtbaar
         van boven terug. Zelfde aanpak als opAnker hierboven. */
      var wortel = document.documentElement, oudGedrag = wortel.style.scrollBehavior;
      wortel.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollVoor);
      wortel.style.scrollBehavior = oudGedrag;
      if (focusVoor && focusVoor.focus) { try { focusVoor.focus({ preventScroll: true }); } catch (e) {} }
    };
    actiefSluit = sluit;

    // Tab mag het venster niet uit zolang het openstaat.
    wrap.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') { return; }
      var kan = wrap.querySelectorAll('button, [href]');
      if (!kan.length) { return; }
      var eerste = kan[0], laatste = kan[kan.length - 1];
      if (e.shiftKey && (document.activeElement === eerste || document.activeElement === kaart)) { e.preventDefault(); laatste.focus(); }
      else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
    });
    wrap.querySelector('.ref-scrim').addEventListener('click', sluit);
    wrap.querySelector('.ref-close').addEventListener('click', sluit);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.contains(wrap)) { sluit(); }
    });
    // Eén tik is genoeg: de korting staat al op de wagen, de pop-up gaat meteen weg.
    wrap.querySelector('.ref-knop').addEventListener('click', sluit);
  };

  // Komt de pagina uit de terug-cache met het venster nog open, dan netjes sluiten.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && actiefSluit) { actiefSluit(); }
  });

  if (!opWinkel) {
    // Losse voorbeeldpagina: geen winkelwagen, alleen laten zien hoe het eruitziet.
    if (viaLink && sessieCode !== '-') { naRust(function () { toon(''); }); }
    return;
  }
  codeVanWagen().then(function (code) {
    // sessieCode telt ook mee: werkt localStorage niet, dan blijft het bij 1x per bezoek.
    var nieuweCode = code !== r.bevestigd && code !== sessieCode;
    var nieuweKlik = viaLink && code !== sessieCode;
    if (code && (nieuweCode || nieuweKlik)) { naRust(function () { toon(code); }); }
  });
})();
/* ---------------------------------------------------------------------------
   Partnerkit. Shopify vult de pagina zelf voor de ingelogde creator (zijn
   klantmetafields custom.partner_*), dus hier zitten alleen de kopieerknoppen.
   De waarde staat op de knop zelf (data-waarde).
--------------------------------------------------------------------------- */
(function () {
  var inner = document.querySelector('.kit-inner');
  if (!inner) { return; }
  Array.prototype.forEach.call(inner.querySelectorAll('.kit-kopieer[data-waarde]'), function (btn) {
    btn.addEventListener('click', function () {
      var tekst = btn.getAttribute('data-waarde');
      if (!tekst) { return; }
      var bron = btn.parentNode.querySelector('code') || btn;
      var klaar = function () {
        /* Het oorspronkelijke label onthouden we op de knop zelf. Lazen we het
           hier opnieuw uit, dan pakt een tweede klik binnen 1,6 s het woord
           "Gekopieerd" op als origineel en blijft dat er voorgoed staan. */
        if (!btn.getAttribute('data-oud')) { btn.setAttribute('data-oud', btn.textContent); }
        if (btn._kopieerTimer) { clearTimeout(btn._kopieerTimer); }
        btn.textContent = btn.getAttribute('data-klaar') || btn.getAttribute('data-oud');
        btn.classList.add('is-klaar');
        btn._kopieerTimer = setTimeout(function () {
          btn.textContent = btn.getAttribute('data-oud');
          btn.classList.remove('is-klaar');
          btn._kopieerTimer = null;
        }, 1600);
      };
      // De klembord-API weigert in een niet-gefocust venster en in sommige
      // in-app browsers (Instagram, TikTok). Faalt hij, dan proberen we de
      // oude weg; faalt die ook, dan selecteren we de tekst zodat de creator
      // hem zelf kan kopieren. Nooit een knop die niets doet.
      var oudeWeg = function () {
        var hulp = document.createElement('textarea');
        hulp.value = tekst;
        hulp.style.position = 'fixed';
        hulp.style.opacity = '0';
        document.body.appendChild(hulp);
        hulp.select();
        var gelukt = false;
        try { gelukt = document.execCommand('copy'); } catch (e) {}
        hulp.remove();
        if (gelukt) { klaar(); return; }
        var bereik = document.createRange();
        bereik.selectNodeContents(bron);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(bereik);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(tekst).then(klaar, oudeWeg);
      } else {
        oudeWeg();
      }
    });
  });
  /* Met de terugknop terug? Dan kan de browser een oude staat van de kit uit
     zijn geheugen tonen: de kit na het uitloggen, het e-mailadres, of de
     inlogknop terwijl je intussen ingelogd bent. Opnieuw laden laat Shopify
     zelf bepalen wat je ziet (een herladen pagina komt niet uit dat geheugen). */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { location.reload(); }
  });
})();

/* Balk bovenaan met meerdere meldingen (v341; op elke breedte sinds v342). Er
   staat een melding tegelijk (zie styles.css); hier zetten we de pijltjes
   aan, laten we vegen toe en wisselen we elke 5 seconden. Na zelf bladeren
   (pijltje of veeg) blijft die melding 7 seconden staan en gaat het wisselen
   daarna verder. Het wisselen pauzeert alleen zolang een pijltje met het
   toetsenbord geselecteerd is en bij een verborgen tabblad; de muis op de
   balk pauzeert bewust niet. Bij "minder beweging" wisselt de balk ook,
   maar zonder schuiven. */
(function () {
  var balk = document.querySelector('[data-ann]');
  if (!balk || !window.matchMedia) { return; }
  var baan = balk.querySelector('.ann-baan');
  var delen = balk.querySelectorAll('.ann-deel');
  var pijlen = balk.querySelectorAll('.ann-pijl');
  if (!baan || delen.length < 2) { return; }
  var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var WACHT = 5000;
  var WACHT_ZELF = 7000;
  var VER = 18;
  var huidig = 0;
  var timer = null;
  var stil = null;
  var focus = false;
  var i;

  var plan = function (wacht) {
    clearTimeout(timer);
    timer = null;
    if (focus || document.hidden) { return; }
    timer = setTimeout(function () { toon((huidig + 1) % delen.length, 1); plan(WACHT); }, wacht);
  };
  var toon = function (naar, richting) {
    if (naar === huidig) { return; }
    var uit = delen[huidig];
    var inn = delen[naar];
    if (!rustig) {
      /* de nieuwe melding staat eerst een stukje opzij, zonder overgang, en schuift dan naar het midden */
      inn.style.transition = 'none';
      inn.style.transform = 'translateX(' + (richting * VER) + 'px)';
      void inn.offsetWidth;
      inn.style.transition = '';
      uit.style.transform = 'translateX(' + (-richting * VER) + 'px)';
    }
    inn.style.transform = '';
    uit.classList.remove('is-actief');
    inn.classList.add('is-actief');
    uit.setAttribute('aria-hidden', 'true');
    inn.removeAttribute('aria-hidden');
    huidig = naar;
  };
  var zelf = function (richting) {
    /* alleen een wissel die de bezoeker zelf doet wordt voorgelezen, het automatische wisselen niet */
    baan.setAttribute('aria-live', 'polite');
    clearTimeout(stil);
    stil = setTimeout(function () { baan.setAttribute('aria-live', 'off'); }, 1500);
    toon((huidig + richting + delen.length) % delen.length, richting);
    plan(WACHT_ZELF);
  };

  /* pijltjes aan, en alleen de zichtbare melding voorlezen */
  for (i = 0; i < pijlen.length; i++) {
    pijlen[i].hidden = false;
    pijlen[i].addEventListener('click', function () { zelf(this.getAttribute('data-ann-stap') === '-1' ? -1 : 1); });
  }
  for (i = 1; i < delen.length; i++) { delen[i].setAttribute('aria-hidden', 'true'); }
  var x0 = null;
  var y0 = null;
  balk.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) { x0 = null; return; }
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
  }, { passive: true });
  balk.addEventListener('touchend', function (e) {
    if (x0 === null || !e.changedTouches.length) { return; }
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) { return; }
    zelf(dx < 0 ? 1 : -1);
  }, { passive: true });
  /* Alleen focus van het toetsenbord pauzeert. Na een tik of klik houdt een knop op sommige telefoons de
     focus vast; dat mag de balk niet stilzetten. Kent de browser :focus-visible niet, dan pauzeert elke focus. */
  balk.addEventListener('focusin', function (e) {
    var toets = true;
    try { toets = e.target.matches(':focus-visible'); } catch (fout) {}
    focus = toets;
    plan(WACHT);
  });
  balk.addEventListener('focusout', function () { focus = false; plan(WACHT); });
  document.addEventListener('visibilitychange', function () { plan(WACHT); });
  plan(WACHT);
})();

/* Nieuwsbriefinschrijver bekend bij Klaviyo (v348). Wie zich inschrijft voor
   de nieuwsbrief of de app-wachtlijst maken we bekend bij Klaviyo, zodat
   Klaviyo het verdere bezoek aan die inschrijver kan koppelen (nodig voor
   "bekeek product" en "liet winkelwagen achter"). Dat doen we alleen als de
   bezoeker marketing- en analysecookies toestaat. Het formulier herlaadt de
   pagina, dus het e-mailadres staat daarvoor heel even in sessionStorage;
   daarna wissen we het altijd, ook als het niet gebruikt is. Een
   partneraanvraag is geen nieuwsbriefinschrijving en doet niet mee. */
(function () {
  var MAIL = 'motionInschrijfMail';
  var opslag = null;
  try { opslag = window.sessionStorage; } catch (fout) {}
  var haal = function () { try { return opslag ? opslag.getItem(MAIL) : null; } catch (fout) { return null; } };
  var zet = function (waarde) { try { if (opslag) { opslag.setItem(MAIL, waarde); } } catch (fout) {} };
  var wis = function () { try { if (opslag) { opslag.removeItem(MAIL); } } catch (fout) {} };
  /* true alleen als Shopify's toestemmings-API er is en beide doelen toestaat; weten we het niet, dan niet */
  var magVolgen = function () {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.marketingAllowed() && cp.analyticsProcessingAllowed());
    } catch (fout) { return false; }
  };

  /* Bij het versturen: met toestemming onthouden we het adres tot de pagina herladen is */
  var lijst = document.querySelectorAll('#footer-signup, form.footer-signup-form, form.app-gate-form');
  for (var i = 0; i < lijst.length; i++) {
    lijst[i].addEventListener('submit', function () {
      wis();
      if (!magVolgen()) { return; }
      var veld = this.querySelector('input[type="email"]');
      var nieuw = veld ? String(veld.value || '').replace(/^\s+|\s+$/g, '') : '';
      if (nieuw) { zet(nieuw); }
    });
  }

  /* Na het herladen: staat de bevestiging er, dan is de inschrijving gelukt */
  var adres = haal();
  wis();
  var gelukt = !!(document.querySelector('.footer-signup-ok') || document.querySelector('.app-gate-form .newsletter-success:not([hidden])'));
  if (!adres || !gelukt) { return; }
  /* Shopify's toestemmings-API laadt soms iets later dan dit script; wacht er hooguit vijf seconden op */
  var pogingen = 0;
  var maakBekend = function () {
    if (magVolgen()) {
      /* Klaviyo's eigen stukje in de pagina zet window.klaviyo klaar als wachtrij, nog voor klaviyo.js
         geladen is; dat is de zekerste weg. _learnq is de oudere weg, voor als die wachtrij er niet is. */
      try {
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email: adres });
        } else {
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', { $email: adres }]);
        }
      } catch (fout) {}
      return;
    }
    if (window.Shopify && window.Shopify.customerPrivacy) { return; }
    if (++pogingen < 20) { setTimeout(maakBekend, 250); }
  };
  maakBekend();
})();
